  document.addEventListener("DOMContentLoaded", function() {
    
    // --- 1. DATABASE (AUTO-GENERATED FROM JSON) ---
    const CDN_BASE = "https://cdn.shopify.com/s/files/1/0974/1847/7877/files/";

    const FABRIC_SPECS = {
            // --- CURTAINS (BYB display names; CDN keys in FABRIC_TRANSLATOR) ---
            "Alva": {
                desc: "A refined sheer with a soft, natural hand and gentle light diffusion.",
                composition: "30% linen",
                features: "• 30% linen<br>• Sheer weave<br>• Soft drape<br>• Custom made to measure",
                included: "1x Custom Sheer Curtain<br>1x Custom Track<br>Installation Brackets (Qty based on width)<br>Mounting Screws (2 per bracket)"
            },
            "Almare": {
                desc: "A clean, contemporary sheer with a linen look and a crisp finish.",
                composition: "Linen-look polyester",
                features: "• Linen-look polyester<br>• Sheer weave<br>• Light filtering<br>• Custom made to measure",
                included: "1x Custom Sheer Curtain<br>1x Custom Track<br>Installation Brackets (Qty based on width)<br>Mounting Screws (2 per bracket)"
            },
            "Lunara": {
                desc: "A linen sheer with textured character and relaxed elegance.",
                composition: "45% linen",
                features: "• 45% linen<br>• Sheer weave<br>• Natural texture<br>• Custom made to measure",
                included: "1x Custom Sheer Curtain<br>1x Custom Track<br>Installation Brackets (Qty based on width)<br>Mounting Screws (2 per bracket)"
            },
            "Velana": {
                desc: "A premium sheer collection with depth, softness and a tailored finish.",
                composition: "30% linen",
                features: "• 30% linen<br>• Sheer weave<br>• Premium drape<br>• Custom made to measure",
                included: "1x Custom Sheer Curtain<br>1x Custom Track<br>Installation Brackets (Qty based on width)<br>Mounting Screws (2 per bracket)"
            },
            "Velora": {
                desc: "A plush velour sheer with a soft drape and refined texture.",
                composition: "Polyester",
                features: "• Polyester<br>• Sheer velour weave<br>• Soft drape<br>• Custom made to measure",
                included: "1x Custom Sheer Curtain<br>1x Custom Track<br>Installation Brackets (Qty based on width)<br>Mounting Screws (2 per bracket)"
            },

            // --- BLINDS ---
            "Sovereign": { 
                desc: "Our elite blockout fabric. Architectural grade with a premium finish.",
                features: "• 100% Polyester<br>• 400gsm Weight<br>• PVC Free & Low Emissions",
                // Specific hardware details added below
                included: "1x Custom Sovereign Blind<br>2x Installation Brackets<br>4x Mounting Screws (2 per bracket)"
            },
            "Urban": { 
                desc: "The essential blockout. Durable, simple, and effective.",
                features: "• 100% Polyester<br>• 350gsm Weight<br>• Fire Retardant",
                included: "1x Custom Urban Blind<br>2x Installation Brackets<br>4x Mounting Screws (2 per bracket)"
            },
            "Zenith": { 
                desc: "A high-performance blockout with superior heat protection.",
                features: "• Pigmented Acrylic Coating<br>• 380gsm Weight<br>• Blue Wool Scale: ≥ 7",
                included: "1x Custom Zenith Blind<br>2x Installation Brackets<br>4x Mounting Screws (2 per bracket)"
            },
            "SolarScreen": { 
                desc: "A technical screen fabric that reduces glare while maintaining the view.",
                features: "• 5%-8% Openness<br>• Antimicrobial Protection<br>• Fire Retardant",
                included: "1x Custom Screen Blind<br>2x Installation Brackets<br>4x Mounting Screws (2 per bracket)"
            },
            "Haven": { 
                desc: "A versatile texture available in both light filtering and blockout options.",
                features: "• Textured Finish<br>• PVC Free<br>• High Durability",
                included: "1x Custom Haven Blind<br>2x Installation Brackets<br>4x Mounting Screws (2 per bracket)"
            }
        };
    
    // SMART FILE MAPPING
    const FILE_SUFFIX_MAP = {
        "windsor": { "optic": "optic-white" }, 
        "zenith": "twc-focus-",
        "solarscreen": "twc-kleenscreen-",
        "metro": {
            "chess": "twc-qube-chess-blockout-hero",
            "cross": "twc-qube-cross-blockout-hero",
            "crypto": "twc-qube-crypto-blockout-hero",
            "eternity": "twc-qube-eternity-blockout-hero",
            "fox": "twc-qube-fox-blockout-hero",
            "geo": "twc-qube-geo-blockout-hero",
            "globe": "twc-qube-globe-blockout-hero",
            "knight": "twc-qube-knight-blockout-hero",
            "lateral": "twc-qube-lateral-blockout-hero",
            "minus": "twc-qube-minus-blockout-hero",
            "peak": "twc-qube-peak-blockout-hero",
            "puzzle": "twc-qube-puzzle-blockout-hero",
            "rubik": "twc-qube-rubik-blockout-hero",
            "soma": "twc-qube-soma-blockout-hero",
            "carbon": "carbon-thumbnail",
            "dice": "dice-zoom",
            "marble": "marble-zoom",
            "rock": "rock-zoom"
        },
        "haven-blockout": "texstyle-sanctuary-",
        "haven-lightfilter": "texstyle-sanctuary-"
    };

    // Helper to generate clean URLs with Smart Mapping
    // CDN overlay/detail1 are swapped on a few SKUs (drape shot uploaded as overlay).
    const FABRIC_PHOTO_SWAPS = {
        'Velana|Pearl': { overlay: 'detail1', detail1: 'overlay' }
    };

    function getUrl(type, category, val) {
        if (!val) return "";
        if (!category) category = "";
        const photoSwap = FABRIC_PHOTO_SWAPS[category + '|' + val];
        if (photoSwap && photoSwap[type]) type = photoSwap[type]; 

        // --- 1. THE TRANSLATOR (Fixes Broken Images) ---
        // This maps your NEW Brand Names back to the OLD keys your code expects
        // Display names (BYB) → first-upload CDN slugs. See docs/fabric-name-map.md
        const FABRIC_TRANSLATOR = {
            "Urban":       "Metro",
            "Sovereign":   "Windsor",
            "Alva":        "Alba",
            "Almare":      "Amalfi",
            "Lunara":      "Linenque",
            "Velana":      "Verana",
            "Velora":      "Velour"
        };
        const COLOUR_TRANSLATOR = {
            "Off White": "Offwhite"
        };

        if (FABRIC_TRANSLATOR[category]) {
            category = FABRIC_TRANSLATOR[category];
        }
        if (type !== 'option' && COLOUR_TRANSLATOR[val]) {
            val = COLOUR_TRANSLATOR[val];
        }
        // -----------------------------------------------------------

        // --- 2. THE "MANUAL MAP" (For Options/Remotes) ---
        const FILENAME_OVERRIDES = {
            "Orbis 1.1NM20 Wirefree": "orbis_1.1nm20_wirefree",
            "Orbis 2NM20 Wirefree":   "orbis_2nm20_wirefree",
            "1 Channel":              "1-channel",
            "15 Channel":             "15-channel",
            "Hub":                    "hub",
            "No Remote":              "no-remote"
        };

        // --- FABRIC DATA LIBRARY ---
        

        let cleanVal = FILENAME_OVERRIDES[val];

        if (!cleanVal) {
            cleanVal = val.toString().toLowerCase().replace(/\s+/g, '-').replace(/[()]/g, '');
        }

        // --- 3. OPTION ICONS (PNG) ---
        if (type === 'option') {
            const themeIcon = window.__BYBOptionIconUrls && window.__BYBOptionIconUrls[category] && window.__BYBOptionIconUrls[category][val];
            if (themeIcon) return themeIcon;

            const optionMap = {
                'mount_blind': 'mounttype',
                'mount_curtain': 'mounttypec',
                'control': 'controlside',
                'roll': 'rolldirection',
                'bracket': 'bracketcolour',
                'motor': 'drivecontrol',
                'motorType': 'motortype', 
                'remote': 'remote',       
                'chain': 'chaintypes',
                'baseShape': 'baserailshape',
                'baseColour': 'baserailcolour',
                'stack': 'stackside',
                'trackColour': 'trackcolour',
                'wand': 'wand',
                'bracketType_curtain': 'brackettypecurtain',
                'wallToWall': 'walltowall'
            };

            let fileCat = optionMap[category] || category.toLowerCase().replace(/\s+/g, '-');
            return `${CDN_BASE}option-${fileCat}-${cleanVal}.png`;
        }

        // --- 4. FABRIC IMAGES (JPG) ---
        let cleanCat = category.toLowerCase().replace(/\s+/g, '-');
        
        // Note: Because of Step 1, 'cleanCat' here will be 'metro' if you selected 'Urban'.
        
        let filename = `${type}-${cleanCat}-${cleanVal}.jpg`;

        // Metro Logic (Works for Urban)
        if (cleanCat === 'metro') {
            const map = FILE_SUFFIX_MAP['metro'];
            if (map && map[cleanVal]) {
                filename = `${type}-metro-${map[cleanVal]}.jpg`;
            } else {
                filename = (type === 'swatch') 
                    ? `${type}-${cleanCat}-${cleanVal}-thumbnail.jpg`
                    : `${type}-${cleanCat}-${cleanVal}-zoom.jpg`;
            }
        }
        // Zenith Logic
        else if (cleanCat === 'zenith') {
            filename = `${type}-${cleanCat}-twc-focus-${cleanVal}.jpg`;
        }
        // SolarScreen Logic
        else if (cleanCat === 'solarscreen') {
            filename = `${type}-${cleanCat}-twc-kleenscreen-${cleanVal}-web.jpg`;
        }
        // Windsor Logic (Works for Sovereign)
        else if (cleanCat === 'windsor') {
            if (cleanVal === 'optic' && type !== 'swatch') cleanVal = 'optic-white';
            filename = (type === 'swatch') 
                ? `${type}-${cleanCat}-${cleanVal}-thumbnail.jpg`
                : `${type}-${cleanCat}-${cleanVal}-zoom.jpg`;
        }
        // Haven Logic
        else if (cleanCat === 'haven') {
            let subType = (state.materialFilter === 'Light Filtering') ? 'lightfilter' : 'blockout';
            if (cleanVal === 'whitewash') {
                filename = (type === 'swatch') 
                    ? `${type}-${cleanCat}-${subType}-${cleanVal}---thumbnail.jpg`
                    : `${type}-${cleanCat}-${subType}-${cleanVal}---zoom.jpg`;
            } else {
                filename = `${type}-${cleanCat}-${subType}-texstyle-sanctuary-${cleanVal}-web.jpg`;
            }
        }

        return `${CDN_BASE}${filename}`;
    }

    const CONSTANTS = {
        options: {
            mount_blind: ['Inside', 'Outside'],
            mount_curtain: ['Top Fit', 'Face Fit'],
            control: ['Left', 'Right'],
            roll: ['Front Roll', 'Back Roll'],
            motor: ['Chain'],
            chain: ['Black Plastic', 'White Plastic', 'Metal'],
            bracket: ['Black', 'White'], 
            baseShape: ['Oval', 'Flat'],
            baseColour: ['Black', 'White', 'Anodised'],
            motorType: ['Orbis 1.1NM20 Wirefree', 'Orbis 2NM20 Wirefree'],
            remote: ['1 Channel', '15 Channel', 'Hub', 'No Remote'],
            stack: ['Left', 'Centre Opening', 'Right'],
            wand: ['910mm', '1220mm', '1520mm', 'None'],
            trackColour: ['White', 'Black'],
            bracketType_curtain: ['Single bracket', 'Double bracket'],
            wallToWall: ['Wall to wall', 'Not wall to wall'],
            hemFinish: ['Lead weight', '70mm hem']
        },
        fabrics: [
            // Availability (sample vs made-to-order) lives in assets/stock.js.
            // Do not delete a fabric here just to take samples off — grey it out there.

            // --- BLINDS ---
            // Budget (Was Metro/Qube) -> New Name: Urban
            { 
                name: "Urban", type: "blind", category: "Blockout", group: "Budget",
                defaultColor: "Carbon",
                colors: ["Dice", "Rock", "Marble", "Carbon"]
            },
            // Group 1 (Zenith = TWC Focus). Base coverage after palette refresh.
            { 
                name: "Zenith", type: "blind", category: "Blockout", group: 1,
                defaultColor: "Espresso",
                colors: ["White", "Shell", "Oyster", "Ash", "Espresso", "Ebony"]
            },
            // Group 1 (SolarScreen)
            { 
                name: "SolarScreen", type: "blind", category: "Screen", group: 1,
                defaultColor: "Charcoal",
                colors: ["PureWhite", "Ivory", "Grey", "Charcoal", "Black"]
            },
            // Group 1 (Haven - Light Filtering)
            { 
                name: "Haven", type: "blind", category: "Light Filtering", group: 1,
                defaultColor: "Lava",
                colors: ["Whitewash", "Plaster", "Marble", "Suede", "Lava"]
            },
            // Group 2 (Haven - Blockout)
            { 
                name: "Haven", type: "blind", category: "Blockout", group: 2,
                defaultColor: "Lava",
                colors: ["Whitewash", "Plaster", "Marble", "Suede", "Lava"]
            },
            // Group 2 (Was Windsor/Endota) -> New Name: Sovereign
            { 
                name: "Sovereign", type: "blind", category: "Blockout", group: 2,
                defaultColor: "Cool Black",
                colors: ["Optic", "Pearl", "Macadamia", "Bamboo", "Gentle Grey", "Cool Black"]
            },

            // --- CURTAINS (BYB names). Upcoming SKUs: docs/fabric-name-map.json ---
            {
                name: "Alva", type: "curtain", category: "Sheer", group: "Group1",
                colors: ["Oat"]
            },
            {
                name: "Almare", type: "curtain", category: "Sheer", group: "PromoGroup",
                colors: ["Off White"]
            },
            {
                name: "Lunara", type: "curtain", category: "Sheer", group: "Group2",
                colors: ["Moon", "Off White", "Desert Mist", "Ivory Mist"]
            },
            {
                name: "Velana", type: "curtain", category: "Sheer", group: "Group1",
                colors: ["Cloud", "Driftwood", "Pearl"]
            },
            {
                name: "Velora", type: "curtain", category: "Sheer", group: "PromoGroup",
                colors: ["Driftwood"]
            }
        ]
    };

    /* Lowest price in matrix: blinds_pricing.json / curtain5off.json (blind-middleware/api). Update when those files change.
       Also update snippets/published-prices.liquid and docs/launch.md. Storefront "from" prices round up to the next dollar.
       Curtain table keys skip Group2 (PromoGroup, Group1, Group3), so theme groups shift:
       Budget → PromoGroup, Group2 → Group3. */
    const FABRIC_GROUP_MIN_AUD = {
        blind: { Budget: 78.64, 1: 82.79, 2: 83.56 },
        curtain: { Group1: 277.64, Group3: 295.49, PromoGroup: 271.97 }
    };
    const CURTAIN_PRICE_GROUP_ALIAS = {
        Budget: 'PromoGroup',
        Group2: 'Group3'
    };

    function resolvePriceGroup(type, group) {
        if (group == null || group === '') return group;
        if (type === 'curtain' && CURTAIN_PRICE_GROUP_ALIAS[String(group)]) {
            return CURTAIN_PRICE_GROUP_ALIAS[String(group)];
        }
        return group;
    }

    function lowestPriceForFabricGroup(fabricType, group) {
        const resolved = fabricType === 'curtain' ? resolvePriceGroup('curtain', group) : group;
        const table = FABRIC_GROUP_MIN_AUD[fabricType];
        if (!table) return null;
        if (table[resolved] != null) return table[resolved];
        const s = String(resolved);
        if (table[s] != null) return table[s];
        return null;
    }

    /* ---- FABRIC SOFT-DELETE GATEWAY ----------------------------------
       Every fabric record in CONSTANTS.fabrics is considered active by
       default. To deprecate a fabric without losing its pricing/group
       link (legacy orders still re-verify against the middleware tables),
       set `is_active: false` on its record. The fabric stays in the
       array (so FABRIC_GROUP_MIN_AUD + historical group lookups keep
       working) but never reaches the DOM.

       Every render path that surfaces fabrics MUST source its list
       through this helper — do NOT iterate CONSTANTS.fabrics directly. */
    function listVisibleFabrics() {
        return CONSTANTS.fabrics.filter(f => f.is_active !== false);
    }

    function stockChannelForMode() {
        return MODE === 'sample' ? 'sample' : 'order';
    }

    function isChannelStocked(channel, fabricName, colour) {
        try {
            if (window.BYBStock && typeof window.BYBStock.isStocked === 'function') {
                return window.BYBStock.isStocked(channel, fabricName, colour);
            }
        } catch (e) { /* fail-open if stock.js has not loaded */ }
        return true;
    }

    function fabricHasStockedColour(channel, fabricObj) {
        return (fabricObj.colors || []).some(c => isChannelStocked(channel, fabricObj.name, c));
    }

    function defaultColourFor(fabricObj, channel) {
        if (!fabricObj || !fabricObj.colors || !fabricObj.colors.length) return null;
        const ch = channel || stockChannelForMode();
        const stocked = fabricObj.colors.filter(c => isChannelStocked(ch, fabricObj.name, c));
        const pool = stocked.length ? stocked : fabricObj.colors;
        if (fabricObj.defaultColor && pool.includes(fabricObj.defaultColor)) {
            return fabricObj.defaultColor;
        }
        return pool[0];
    }

    function formatAudPrice(amount) {
        return '$' + Number(amount).toFixed(2);
    }

    const WALL_TO_WALL_DEDUCT_MM = 20; // mill truth is middleware lib/curtain-math.js

    function isWallToWall() {
        return MODE === 'curtain' && state.options.wallToWall === 'Wall to wall';
    }

    function getFinishedTrackWidth(enteredWidth) {
        const w = Number.isFinite(enteredWidth) ? enteredWidth : (state.width || 0);
        if (!isWallToWall()) return w;
        return Math.max(0, w - WALL_TO_WALL_DEDUCT_MM);
    }

    function getMeasureLimits() {
        const deduct = isWallToWall() ? WALL_TO_WALL_DEDUCT_MM : 0;
        return {
            minW: 250 + deduct,
            minD: 250,
            maxW: (MODE === 'curtain' ? 5750 : 3000) + deduct,
            maxD: MODE === 'blind' ? 3000 : 3100
        };
    }

    function updateTopFixNote() {
        const note = document.getElementById('cfg-topfix-note');
        if (!note) return;
        note.hidden = !(MODE === 'curtain' && state.options.mount_curtain === 'Top Fit');
    }

    function setLimitHelper(id, label, value, min, max, message) {
        const el = document.getElementById(id);
        if (!el) return;
        let error = message || '';
        if (!error && value > max) error = `Max ${label} is ${max}mm`;
        else if (!error && value > 0 && value < min) error = `Min ${label} is ${min}mm`;
        el.textContent = error || `Min ${min}mm to Max ${max}mm`;
        el.classList.toggle('text-error', !!error);
    }

    function updateLimitHelpers() {
        const limits = getMeasureLimits();
        setLimitHelper('width-limit-text', 'width', state.width || 0, limits.minW, limits.maxW);
        setLimitHelper('drop-limit-text', 'drop', state.drop || 0, limits.minD, limits.maxD);
    }

    function updateCurtainMeasureCopy() {
        if (MODE !== 'curtain') return;
        updateLimitHelpers();

        const widthHelp = document.getElementById('cfg-width-help');
        if (widthHelp) {
            if (state.options.wallToWall === 'Wall to wall') {
                widthHelp.textContent = 'Enter the full opening width. We deduct 20mm (10mm each side).';
            } else if (state.options.wallToWall === 'Not wall to wall') {
                widthHelp.textContent = 'Enter the finished track length we should make.';
            } else {
                widthHelp.textContent = 'Select wall to wall or not, then enter millimetres.';
            }
        }

        const makeNote = document.getElementById('cfg-track-make-note');
        if (makeNote) {
            const w = state.width || 0;
            if (!state.options.wallToWall || w <= 0) {
                makeNote.hidden = true;
                makeNote.textContent = '';
            } else if (isWallToWall()) {
                const finished = getFinishedTrackWidth(w);
                makeNote.hidden = false;
                makeNote.textContent = `We'll make a ${finished}mm track. 20mm deducted (10mm each side).`;
            } else {
                makeNote.hidden = false;
                makeNote.textContent = `We'll make the track to ${w}mm. No width deduction.`;
            }
        }
    }

    function updatePriceDisplay(text, options = {}) {
        const { loading = false } = options;
        const priceDisplay = document.getElementById('custom-display-price');
        if (!priceDisplay) return;

        if (!priceDisplay.dataset.priceRetryBound) {
            priceDisplay.dataset.priceRetryBound = 'true';
            priceDisplay.addEventListener('click', () => {
                if (priceDisplay.innerText === 'Error') {
                    window.calculatePrice({ immediate: true });
                }
            });
        }

        priceDisplay.innerText = text;
        priceDisplay.classList.remove('cfg-price-value--placeholder');
        priceDisplay.style.opacity = loading ? '0.5' : '1';
        if (text === 'Error') {
            priceDisplay.title = 'Price lookup failed. Tap to retry.';
            priceDisplay.style.cursor = 'pointer';
        } else {
            priceDisplay.removeAttribute('title');
            priceDisplay.style.cursor = '';
        }

        document.querySelectorAll('.cfg-price-mirror').forEach(el => {
            el.innerText = text;
            el.classList.remove('cfg-price-value--placeholder');
        });
    }

    function resetPriceDisplay() {
        state.price = 0;
        const priceDisplay = document.getElementById('custom-display-price');
        const placeholder = '—';
        if (priceDisplay) {
            priceDisplay.innerText = placeholder;
            priceDisplay.classList.add('cfg-price-value--placeholder');
            priceDisplay.style.opacity = '1';
        }
        document.querySelectorAll('.cfg-price-mirror').forEach(el => {
            if (el === priceDisplay) return;
            el.innerText = placeholder;
            el.classList.add('cfg-price-value--placeholder');
        });
    }

    function fabricImageAlt(fabricName, colourName, suffix) {
        const base = `${fabricName} ${colourName}`.trim();
        return suffix ? `${base}, ${suffix}` : base;
    }

    // --- 2. CONFIG STATE ---
    const MODE = window.__configuratorMode || "";
    let _vizUiReady = false;
    let state = {
        width: 0,
        drop: 0,
        fabric: null, 
        colour: null, 
        doubleSheerFabric: null,
        doubleSheerColour: null,
        doubleBlockoutFabric: null,
        doubleBlockoutColour: null,
        options: {},
        sampleType: 'Blinds', // Default
        materialFilter: 'Blockout' // Default
    };

    function isDoubleCurtainMode() {
        return MODE === 'curtain' && state.materialFilter === 'Double';
    }

    function resetDoubleCurtainState() {
        state.doubleSheerFabric = null;
        state.doubleSheerColour = null;
        state.doubleBlockoutFabric = null;
        state.doubleBlockoutColour = null;
    }

    function applyCurtainMaterialVisual() {
        if(MODE !== 'curtain') return;
        const v = document.getElementById('blind-visualizer');
        if(!v) return;
        if(state.materialFilter === 'Blockout') {
            v.classList.remove('mode-sheer');
            v.classList.add('mode-blockout');
        } else {
            v.classList.add('mode-sheer');
            v.classList.remove('mode-blockout');
        }
        // Canvas engine owns the room plate (v7). Do not hydrate the old Gemini/curtback
        // images first — that flashes the legacy photo and sizes the mask off-centre.
        if ((window.__visualizerEngine || 'canvas') !== 'legacy') {
            scheduleVisualizerRefresh();
            return;
        }
        const bg = v.querySelector('.visualizer-bg');
        const nextSrc = state.materialFilter === 'Blockout'
            ? "https://cdn.shopify.com/s/files/1/0974/1847/7877/files/curtback_1.webp?v=1765857592"
            : "https://cdn.shopify.com/s/files/1/0974/1847/7877/files/Gemini_Generated_Image_l5drfsl5drfsl5dr.webp?v=1765925333";
        if(bg) {
            bg.dataset.src = nextSrc;
            if(isVizDrawerOpen()) bg.src = nextSrc;
        }
        scheduleVisualizerRefresh();
    }

    function syncCurtainModeUi() {
        if(MODE !== 'curtain') return;
        const isDouble = isDoubleCurtainMode();
        const isBlockoutEmpty = state.materialFilter === 'Blockout' && getVisibleFabricsForCurrentFilter().length === 0;
        const singleWrap = document.getElementById('single-curtain-selection');
        const doubleWrap = document.getElementById('double-curtain-selection');
        const soonEl = document.getElementById('cfg-curtain-soon');

        if(soonEl) soonEl.hidden = !isBlockoutEmpty;
        if(singleWrap) {
            if(isDouble || isBlockoutEmpty) singleWrap.style.display = 'none';
            else singleWrap.style.display = 'block';
        }
        if(doubleWrap) doubleWrap.style.display = isDouble ? 'block' : 'none';

        const bracketWrap = document.getElementById('bracket-type-curtain-wrapper');
        if(bracketWrap) {
            if(isDouble) {
                bracketWrap.style.display = 'none';
                state.options.bracketType_curtain = 'Double bracket';
            } else {
                bracketWrap.style.display = (state.options.mount_curtain === 'Face Fit') ? 'block' : 'none';
            }
        }

        updateStepNavButtons();
    }

    // --- 3. INIT UI ---
    function init() {
        if(MODE === 'blind') {
            // Updated to use specific blind key
            renderOptions('mount_blind', 'mount-options-container');
            renderOptions('control', 'control-options-container');
            renderOptions('roll', 'roll-options-container');
            renderOptions('bracket', 'bracket-options-container');
            renderOptions('motor', 'motor-options-container');
            renderOptions('chain', 'chain-options-container');
            renderOptions('baseShape', 'base-shape-container');
            renderOptions('baseColour', 'base-colour-container');
            renderOptions('motorType', 'motor-type-options-container');
            renderOptions('remote', 'remote-options-container');
            
            state.materialFilter = 'Blockout';
            state.options.motor = 'Chain';
            renderFabrics();
            const chainWrap = document.getElementById('chain-group-wrapper');
            if(chainWrap) chainWrap.style.display = 'block';
        } 
        else if (MODE === 'curtain') {
            // Updated to use specific curtain key
            renderOptions('mount_curtain', 'mount-options-container');
            renderOptions('bracketType_curtain', 'bracket-type-curtain-container');
            renderOptions('stack', 'stack-options-container');
            renderOptions('wand', 'wand-options-container');
            renderOptions('trackColour', 'track-colour-container');
            renderOptions('hemFinish', 'hem-options-container');
            renderOptions('wallToWall', 'wall-to-wall-container');
            updateCurtainMeasureCopy();
            updateTopFixNote();
            
            state.materialFilter = 'Sheer';
            applyCurtainMaterialVisual();
            syncCurtainModeUi();
            renderFabrics();
        }
        else if (MODE === 'sample') {
            initSamplePage();
        }

        initializeTooltips();
        
        document.querySelectorAll('input[type=number]').forEach(input => {
            input.addEventListener('wheel', (e) => e.preventDefault());
        });
        
        // Remove error class on text input change
        const nameInputs = document.querySelectorAll('.tech-input-field[type="text"]');
        nameInputs.forEach(input => {
            input.addEventListener('input', function() {
                if(this.value.trim().length > 0) {
                    if (this.classList.contains('cfg-reference-input')) {
                        setReferenceNameError(false);
                    } else {
                        this.closest('.tech-input-wrapper')?.classList.remove('input-error');
                    }
                    updateProgressBubbles();
                }
            });
        });
    }

    function getReferenceNameInput() {
        return MODE === 'blind'
            ? document.getElementById('custom-input-name-b')
            : document.getElementById('custom-input-name-c');
    }

    function setReferenceNameError(hasError) {
        const nameInput = getReferenceNameInput();
        if (!nameInput) return;
        const wrapper = nameInput.closest('.tech-input-wrapper');
        const section = nameInput.closest('.cfg-window-name') || nameInput.closest('.cfg-reference');
        const title = section?.querySelector('.cfg-reference-title') || section?.querySelector('.cfg-window-name-label');
        if (hasError) {
            wrapper?.classList.add('input-error');
            section?.classList.add('is-invalid');
            title?.classList.add('text-error');
        } else {
            wrapper?.classList.remove('input-error');
            section?.classList.remove('is-invalid');
            title?.classList.remove('text-error');
        }
    }

    function clearValidationErrors() {
        document.querySelectorAll('.input-error').forEach(el => el.classList.remove('input-error'));
        document.querySelectorAll('.text-error').forEach(el => el.classList.remove('text-error'));
        document.querySelectorAll('.cfg-reference.is-invalid, .cfg-window-name.is-invalid').forEach(el => el.classList.remove('is-invalid'));
    }

    // --- 4. STATE MANAGEMENT ---
    function resetSelection() {
        state.fabric = null;
        state.colour = null;
        resetDoubleCurtainState();
        state.price = 0;

        const fabGridId = (MODE === 'sample') ? 'sample-fabric-grid' : 'fabric-grid';
        const fabGrid = document.getElementById(fabGridId);
        if(fabGrid) {
            fabGrid.querySelectorAll('.fabric-swatch').forEach(s => s.classList.remove('selected'));
        }

        const colGridId = (MODE === 'sample') ? 'sample-colour-grid' : 'colour-grid';
        const colGrid = document.getElementById(colGridId);
        if(colGrid) {
            colGrid.innerHTML = '<div class="loading-state">Select a fabric first...</div>';
        }

        const sheerGrid = document.getElementById('double-sheer-colour-grid');
        if(sheerGrid) sheerGrid.innerHTML = '<div class="loading-state">Select Sheer fabric first...</div>';
        const blockoutGrid = document.getElementById('double-blockout-colour-grid');
        if(blockoutGrid) blockoutGrid.innerHTML = '<div class="loading-state">Select Blockout fabric first...</div>';

        if(MODE === 'sample') {
            const container = document.getElementById('colour-group-container');
            if(container) {
                container.style.opacity = '0.5';
                container.style.pointerEvents = 'none';
            }
            document.getElementById('selection-summary').innerText = "No sample selected";
        }

        resetPriceDisplay();
        clearFabricVisuals();
    }

    // --- 5. RENDERERS ---
    const OPTION_HELP = {
        mount_blind: { Inside: 'Fits inside the window recess.', Outside: 'Covers the full window frame.' },
        mount_curtain: { 'Top Fit': 'Mounts to the ceiling or top of the recess.', 'Face Fit': 'Mounts to the wall or architrave.' },
        stack: { Left: 'Curtains stack to the left when open.', Right: 'Curtains stack to the right when open.', 'Centre Opening': 'Split pair stacks to both sides.' },
        wallToWall: { 'Wall to wall': 'We deduct 20mm (10mm each side) from the width you enter.', 'Not wall to wall': 'We make the track to the exact width you enter.' },
        hemFinish: {
            'Lead weight': 'A slim hem with discreet weights. Keeps tall drops hanging straight.',
            '70mm hem': 'A deeper folded hem. The tailored finish for any fabric.'
        }
    };

    function hemDiagramSvg(kind) {
        const deep = kind === '70mm hem';
        const folds = [44, 76, 108, 140, 172, 204].map((x, i) => {
            const strong = i % 2 === 0;
            const stroke = strong ? '1.5' : '1.2';
            const opacity = strong ? '1' : '0.4';
            const end = deep ? 104 : 142;
            return `<path d="M${x} 20 L${x} ${end}" stroke="#1A1A1A" stroke-width="${stroke}" stroke-linecap="round" opacity="${opacity}"/>`;
        }).join('');
        const hemFolds = deep
            ? [44, 76, 108, 140, 172, 204].map((x, i) => {
                const strong = i % 2 === 0;
                return `<path d="M${x} 106 L${x} 142" stroke="#1A1A1A" stroke-width="${strong ? '1.5' : '1.2'}" stroke-linecap="round" opacity="${strong ? '1' : '0.35'}"/>`;
            }).join('')
            : '';
        const wave = 'M26 142 C34 145, 36 139, 44 142 C52 145, 68 139, 76 142 C84 145, 100 139, 108 142 C116 145, 132 139, 140 142 C148 145, 164 139, 172 142 C180 145, 196 139, 204 142 C212 145, 222 141, 232 142';
        const turn = 'M26 106 C34 109, 36 103, 44 106 C52 109, 68 103, 76 106 C84 109, 100 103, 108 106 C116 109, 132 103, 140 106 C148 109, 164 103, 172 106 C180 109, 196 103, 204 106 C212 109, 222 105, 232 106';
        const band = deep
            ? `<path d="${turn} L232 142 C222 141, 212 145, 204 142 C196 139, 180 145, 172 142 C164 139, 148 145, 140 142 C132 139, 116 145, 108 142 C100 139, 84 145, 76 142 C68 139, 52 145, 44 142 C36 139, 34 145, 26 142 Z" fill="#F6F3EE"/>${hemFolds}<path d="${turn}" stroke="#1A1A1A" stroke-width="1.2" stroke-linecap="round" fill="none"/><path d="M26 109 C34 112, 36 106, 44 109 C52 112, 68 106, 76 109 C84 112, 100 106, 108 109 C116 112, 132 106, 140 109 C148 112, 164 106, 172 109 C180 112, 196 106, 204 109 C212 112, 222 108, 232 109" stroke="#9E988D" stroke-width="0.8" stroke-dasharray="3 1.5" stroke-linecap="round" fill="none"/>`
            : `<path d="M26 136 C34 139, 36 133, 44 136 C52 139, 68 133, 76 136 C84 139, 100 133, 108 136 C116 139, 132 133, 140 136 C148 139, 164 133, 172 136 C180 139, 196 133, 204 136 C212 139, 222 135, 232 136" stroke="#8E8E8E" stroke-width="0.85" stroke-linecap="round" fill="none"/><circle cx="44" cy="139" r="3.2" fill="#1A1A1A"/><circle cx="108" cy="139" r="3.2" fill="#1A1A1A"/><circle cx="172" cy="139" r="3.2" fill="#1A1A1A"/>`;
        return `<svg class="cfg-hem-svg" viewBox="0 0 260 170" fill="none" aria-hidden="true">
            <line x1="20" y1="18" x2="240" y2="18" stroke="#1A1A1A" stroke-width="1.75" stroke-linecap="round"/>
            <circle cx="44" cy="18" r="2.2" fill="#1A1A1A"/><circle cx="76" cy="18" r="2.2" fill="#1A1A1A"/><circle cx="108" cy="18" r="2.2" fill="#1A1A1A"/><circle cx="140" cy="18" r="2.2" fill="#1A1A1A"/><circle cx="172" cy="18" r="2.2" fill="#1A1A1A"/><circle cx="204" cy="18" r="2.2" fill="#1A1A1A"/>
            ${folds}
            ${band}
            <path d="${wave}" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" fill="none"/>
            <line x1="20" y1="152" x2="240" y2="152" stroke="#E5E5E5" stroke-width="0.75" stroke-dasharray="3 3"/>
        </svg>`;
    }

    function renderOptions(key, containerId) {
        const container = document.getElementById(containerId);
        if(!container) return;
        container.innerHTML = "";
        
        // Color Pop Logic: Identify if this key requires the pop effect
        const colorKeys = ['bracket', 'baseColour', 'trackColour'];
        const isColorOption = colorKeys.includes(key);
        
        const list = CONSTANTS.options[key] || [];
        list.forEach(optVal => {
            const card = document.createElement('label');
            card.className = 'ind-radio-card';
            
            const iconUrl = getUrl("option", key, optVal);
            
            const visual = document.createElement('div');
            visual.className = 'card-visual';
            
            // CHANGED: conditionally add the 'color-pop-img' class
            const imgClass = isColorOption ? 'card-visual-img color-pop-img' : 'card-visual-img';

            if (key === 'hemFinish') {
                visual.classList.add('cfg-hem-art');
                visual.innerHTML = hemDiagramSvg(optVal);
            } else {
                const img = document.createElement('img');
                img.dataset.src = iconUrl;
                img.className = imgClass;
                img.alt = `${optVal} option`;
                img.decoding = 'async';
                img.src = iconUrl;
                img.onerror = function() {
                    this.style.display = 'none';
                    this.parentNode.innerText = optVal.substring(0, 3).toUpperCase();
                };
                visual.appendChild(img);
            }

            const label = document.createElement('div');
            label.className = 'radio-label-text';
            label.innerText = optVal;

            const helpMap = OPTION_HELP[key];
            const helpText = helpMap && helpMap[optVal];
            if (helpText) {
                const help = document.createElement('div');
                help.className = 'radio-label-help';
                help.innerText = helpText;
                card.appendChild(visual);
                card.appendChild(label);
                card.appendChild(help);
            } else {
                card.appendChild(visual);
                card.appendChild(label);
            }
            
            if(state.options[key] === optVal) {
                card.classList.add('selected');
            }

            card.onclick = () => {
                container.querySelectorAll('.ind-radio-card').forEach(c => c.classList.remove('selected'));
                card.classList.add('selected');
                popOptionCard(card);
                state.options[key] = optVal;
                
                const parentGroup = container.closest('.ind-form-group');
                if(parentGroup) parentGroup.querySelector('.ind-label').classList.remove('text-error');
                container.classList.remove('input-error');
                
                if(key === 'motor') {
                    const isMotor = optVal.toLowerCase().includes('motor'); // Checks if "Motorised" selected
                    
                    // Toggle Chain
                    const chainWrap = document.getElementById('chain-group-wrapper');
                    if(chainWrap) chainWrap.style.display = isMotor ? 'none' : 'block';

                    // Toggle New Options
                    const typeWrap = document.getElementById('motor-type-wrapper');
                    if(typeWrap) typeWrap.style.display = isMotor ? 'block' : 'none';

                    const remoteWrap = document.getElementById('remote-wrapper');
                    if(remoteWrap) remoteWrap.style.display = isMotor ? 'block' : 'none';
                }
                if(key === 'mount_curtain') {
                    const bracketWrap = document.getElementById('bracket-type-curtain-wrapper');
                    if(isDoubleCurtainMode()) {
                        if(bracketWrap) bracketWrap.style.display = 'none';
                        state.options.bracketType_curtain = 'Double bracket';
                    } else {
                        if(bracketWrap) bracketWrap.style.display = (optVal === 'Face Fit') ? 'block' : 'none';
                        if(optVal !== 'Face Fit') delete state.options.bracketType_curtain;
                    }
                    const bracketGroup = document.querySelector('#bracket-type-curtain-container')?.closest('.ind-form-group');
                    if(bracketGroup) bracketGroup.querySelector('.ind-label')?.classList.remove('text-error');
                    updateTopFixNote();
                }
                if(key === 'wallToWall') {
                    updateCurtainMeasureCopy();
                }
                // Blind lab: roll is collected for the order but does not change the photo yet.
                if (!(MODE === 'blind' && window.__BYBVizLab === 'blind' && key === 'roll')) {
                    scheduleVisualizerRefresh();
                }
                if (key === 'mount_blind' || key === 'mount_curtain' || key === 'stack' || key === 'trackColour'
                    || (MODE === 'blind' && window.__BYBVizLab === 'blind' && (key === 'control' || key === 'bracket'))) {
                    nudgeVizPill();
                }
                updateProgressBubbles();
                calculatePrice();
                syncFocusGroups();
            };
            container.appendChild(card);
        });
    }

    function prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function popOptionCard(card) {
        if(prefersReducedMotion()) return;
        card.classList.add('cfg-card--pop');
        const remove = (e) => {
            if(e && e.target !== card) return;
            card.classList.remove('cfg-card--pop');
            card.removeEventListener('animationend', remove);
        };
        card.addEventListener('animationend', remove);
    }

    function pulseAtcButton() {
        if(prefersReducedMotion()) return;
        const btn = document.getElementById('master-atc-btn');
        if(!btn) return;
        btn.classList.add('cfg-atc-pulse');
        const remove = () => {
            btn.classList.remove('cfg-atc-pulse');
            btn.removeEventListener('animationend', remove);
        };
        btn.addEventListener('animationend', remove);
        setTimeout(remove, 1400);
    }

    const STEP_CHROME = {
        blind: {
            1: { eyebrow: 'Step 1 of 4', title: 'Choose fabric & colour', sub: 'This is the cloth you will see in the room.' },
            2: { eyebrow: 'Step 2 of 4', title: 'Enter width & drop', sub: 'Millimetres. Check the measurement guide if unsure.' },
            3: { eyebrow: 'Step 3 of 4', title: 'Choose hardware', sub: 'One pick per row. The gold tile is selected; the others fade.' },
            4: { eyebrow: 'Last step', title: 'Choose your chain', sub: 'Then add to cart. You are done configuring.' }
        },
        curtain: {
            1: { eyebrow: 'Step 1 of 4', title: 'Choose fabric & colour', sub: 'This is the cloth you will see in the room.' },
            2: { eyebrow: 'Step 2 of 4', title: 'Enter width & drop', sub: 'Choose wall to wall or not, then enter millimetres.' },
            3: { eyebrow: 'Step 3 of 4', title: 'Choose hang & stack', sub: 'One pick per row. The gold tile is selected; the others fade.' },
            4: { eyebrow: 'Last step', title: 'Choose your wand', sub: 'Then add to cart. You are done configuring.' }
        }
    };

    function syncStepChrome(n) {
        if(MODE === 'sample') return;
        const chrome = STEP_CHROME[MODE]?.[n];
        if(!chrome) return;
        const eyebrow = document.querySelector('.cfg-form-eyebrow');
        const title = document.querySelector('.cfg-form-title');
        const sub = document.querySelector('.cfg-form-sub');
        if(eyebrow) eyebrow.textContent = chrome.eyebrow;
        if(title) title.textContent = chrome.title;
        if(sub) sub.textContent = chrome.sub;
    }

    function isFormGroupVisible(group) {
        if(!group) return false;
        if(group.offsetParent !== null) return true;
        const rects = group.getClientRects();
        return rects.length > 0 && getComputedStyle(group).display !== 'none';
    }

    function isFormGroupDone(group) {
        const radioRow = group.querySelector('.ind-radio-row');
        if(radioRow) {
            return !!radioRow.querySelector('.ind-radio-card.selected');
        }
        const fabricGrid = group.querySelector('.ind-fabric-grid');
        if(fabricGrid) {
            return !!fabricGrid.querySelector('.selected');
        }
        return null;
    }

    function syncFocusGroups() {
        if(MODE === 'sample') return;
        const openStepEl = document.querySelector('.cfg-step.cfg-step--open');
        if(!openStepEl) return;

        const groups = openStepEl.querySelectorAll('.cfg-step-body > .ind-form-group');
        let focusAssigned = false;

        groups.forEach(group => {
            group.classList.remove('cfg-group--focus', 'cfg-group--done');
            if(!isFormGroupVisible(group)) return;

            const doneState = isFormGroupDone(group);
            if(doneState === null) return;

            if(doneState) {
                group.classList.add('cfg-group--done');
            } else if(!focusAssigned) {
                group.classList.add('cfg-group--focus');
                focusAssigned = true;
            }
        });
    }

    function syncStepRecap(n) {
        const recap = document.getElementById('cfg-step-recap');
        if(!recap) return;
        if(n !== 4) {
            recap.hidden = true;
            return;
        }
        recap.hidden = false;
        const list = document.getElementById('cfg-step-recap-list');
        if(list) {
            const rows = buildSummaryRows();
            const lastLabel = MODE === 'blind' ? 'Chain Type' : 'Wand Length';
            const keep = new Set(['Fabric', 'Sheer', 'Blockout', 'Size', 'Mount', 'Hem', lastLabel]);
            const picked = rows.filter(r => keep.has(r.label)).slice(0, 6);
            list.innerHTML = picked.map(r => `<li>${r.label}: ${r.value}</li>`).join('');
        }
    }

    function emptyFabricGridMessage(category) {
        if (MODE === 'curtain' && category === 'Blockout') {
            return "<div class='loading-state'>Coming soon</div>";
        }
        return "<div class='loading-state'>No fabrics found.</div>";
    }

    function getVisibleFabricsForCurrentFilter() {
        return listVisibleFabrics().filter(f => {
            if (MODE === 'sample') {
                if (state.sampleType === 'Blinds') return f.type === 'blind';
                return f.type === 'curtain';
            }
            if (f.type !== MODE) return false;
            return f.category === state.materialFilter;
        });
    }

    function markSwatchSelected(grid, matchLabel) {
        if (!grid) return;
        grid.querySelectorAll('.fabric-swatch').forEach(s => {
            const lbl = s.querySelector('.swatch-label');
            s.classList.toggle('selected', lbl?.innerText === matchLabel);
        });
    }

    function applyColourSelection(fabricObj, colorName, colourGridId) {
        if (MODE !== 'sample' && !isChannelStocked('order', fabricObj.name, colorName)) return;
        const cGridId = colourGridId || (MODE === 'sample' ? 'sample-colour-grid' : 'colour-grid');
        state.colour = colorName;
        markSwatchSelected(document.getElementById(cGridId), colorName);
        const gridEl = document.getElementById(cGridId);
        if (gridEl) gridEl.classList.remove('input-error');

        if (MODE === 'sample') {
            document.getElementById('selection-summary').innerText = `Selected: ${fabricObj.name} ${colorName}`;
        } else {
            updateFabricVisuals(fabricObj.name, colorName);
            calculatePrice();
            nudgeVizPill();
        }
        updateProgressBubbles();
    }

    function selectFabric(fabricObj, options = {}) {
        if (MODE !== 'sample' && !fabricHasStockedColour('order', fabricObj)) return;
        const fabricGridId = options.fabricGridId || (MODE === 'sample' ? 'sample-fabric-grid' : 'fabric-grid');
        const colourGridId = options.colourGridId;
        const fabricGrid = document.getElementById(fabricGridId);

        markSwatchSelected(fabricGrid, fabricObj.name);
        if (fabricGrid) fabricGrid.classList.remove('input-error');

        state.fabric = fabricObj;
        updateInfoTabs(fabricObj.name);

        if (MODE === 'sample') {
            const container = document.getElementById('colour-group-container');
            if (container) {
                container.style.opacity = '1';
                container.style.pointerEvents = 'auto';
            }
        }

        renderColours(fabricObj, colourGridId);

        if (fabricObj.colors && fabricObj.colors.length > 0) {
            applyColourSelection(fabricObj, defaultColourFor(fabricObj), colourGridId);
        } else {
            state.colour = null;
            if (MODE !== 'sample') clearFabricVisuals();
            updateProgressBubbles();
        }
    }

    function applyDefaultFabricSelection() {
        if (MODE === 'sample' || isDoubleCurtainMode()) return;
        const filtered = getVisibleFabricsForCurrentFilter().filter(f => fabricHasStockedColour('order', f));
        if (filtered.length === 0) return;
        selectFabric(filtered[0]);
    }

    function renderFabrics() {
        syncCurtainModeUi();
        if(isDoubleCurtainMode()) {
            renderDoubleCurtainFabrics();
            return;
        }

        const gridId = (MODE === 'sample') ? 'sample-fabric-grid' : 'fabric-grid';
        const grid = document.getElementById(gridId);
        if(!grid) return;
        grid.innerHTML = "";

        const filtered = getVisibleFabricsForCurrentFilter();

        if(filtered.length === 0) grid.innerHTML = emptyFabricGridMessage(state.materialFilter);

        filtered.forEach(f => {
            const swatch = buildFabricSwatch(f);
            swatch.onclick = () => {
                if (MODE !== 'sample' && !fabricHasStockedColour('order', f)) return;
                selectFabric(f, { fabricGridId: gridId });
            };
            grid.appendChild(swatch);
        });

        if (MODE === 'blind' || MODE === 'curtain') {
            applyDefaultFabricSelection();
        }
    }

    function applyOosState(swatch, isOos) {
        swatch.classList.toggle('fabric-swatch--oos', !!isOos);
        if (isOos) swatch.setAttribute('aria-disabled', 'true');
        else swatch.removeAttribute('aria-disabled');
        const vis = swatch.querySelector('.swatch-visual');
        if (!vis) return;
        let badge = vis.querySelector('.swatch-oos-badge');
        if (isOos) {
            if (!badge) {
                badge = document.createElement('div');
                badge.className = 'swatch-oos-badge';
                badge.textContent = 'Out of stock';
                vis.appendChild(badge);
            }
        } else if (badge) {
            badge.remove();
        }
    }

    function buildFabricSwatch(fabricObj) {
        const swatch = document.createElement('div');
        swatch.className = 'fabric-swatch';
        const firstColor = defaultColourFor(fabricObj);
        const thumbUrl = getUrl("swatch", fabricObj.name, firstColor);

        const vis = document.createElement('div');
        vis.className = 'swatch-visual';
        if (MODE === 'sample') vis.style.backgroundImage = `url('${thumbUrl}')`;
        const photo = document.createElement('img');
        photo.className = 'swatch-photo';
        photo.src = thumbUrl;
        photo.alt = fabricObj.name;
        photo.decoding = 'async';
        vis.appendChild(photo);

        const fromBadge = document.createElement('div');
        fromBadge.className = 'swatch-from-price';
        fromBadge.setAttribute('aria-hidden', 'true');
        const fromMin = lowestPriceForFabricGroup(fabricObj.type, fabricObj.group);
        if (fromMin != null) {
            fromBadge.textContent = 'From $' + Math.ceil(Number(fromMin));
            fromBadge.hidden = false;
        } else {
            fromBadge.hidden = true;
        }
        vis.appendChild(fromBadge);

        const lbl = document.createElement('div');
        lbl.className = 'swatch-label';
        lbl.innerText = fabricObj.name;
        swatch.appendChild(vis);
        swatch.appendChild(lbl);
        const composition = FABRIC_SPECS[fabricObj.name]?.composition;
        if (composition) {
            const comp = document.createElement('div');
            comp.className = 'swatch-composition';
            comp.textContent = composition;
            swatch.appendChild(comp);
        }
        applyOosState(swatch, !fabricHasStockedColour(stockChannelForMode(), fabricObj));
        return swatch;
    }

    function buildColourSwatch(fabricObj, colorName) {
        const swatch = document.createElement('div');
        swatch.className = 'fabric-swatch';
        const url = getUrl("swatch", fabricObj.name, colorName);
        const vis = document.createElement('div');
        vis.className = 'swatch-visual';
        if (MODE === 'sample') vis.style.backgroundImage = `url('${url}')`;
        const photo = document.createElement('img');
        photo.className = 'swatch-photo';
        photo.src = url;
        photo.alt = colorName;
        photo.decoding = 'async';
        vis.appendChild(photo);
        const lbl = document.createElement('div');
        lbl.className = 'swatch-label';
        lbl.innerText = colorName;
        swatch.appendChild(vis);
        swatch.appendChild(lbl);
        applyOosState(swatch, !isChannelStocked(stockChannelForMode(), fabricObj.name, colorName));
        return swatch;
    }

    function renderColours(fabricObj, colourGridId) {
        const cGridId = colourGridId || (MODE === 'sample' ? 'sample-colour-grid' : 'colour-grid');
        const grid = document.getElementById(cGridId);
        if(!grid) return;
        grid.innerHTML = "";
        
        if(!fabricObj.colors || fabricObj.colors.length === 0) {
            grid.innerHTML = "<div class='loading-state'>No colours available.</div>";
            return;
        }

        fabricObj.colors.forEach(colorName => {
            const swatch = buildColourSwatch(fabricObj, colorName);
            swatch.onclick = () => {
                if (MODE !== 'sample' && !isChannelStocked('order', fabricObj.name, colorName)) return;
                applyColourSelection(fabricObj, colorName, cGridId);
            };
            grid.appendChild(swatch);
        });
        prefetchVizAlbedo(fabricObj);
    }

    function renderDoubleCurtainFabrics() {
        renderLayerFabricGrid('Sheer', 'double-sheer-fabric-grid', 'double-sheer-colour-grid', 'doubleSheerFabric', 'doubleSheerColour');
        renderLayerFabricGrid('Blockout', 'double-blockout-fabric-grid', 'double-blockout-colour-grid', 'doubleBlockoutFabric', 'doubleBlockoutColour');
    }

    function renderLayerFabricGrid(category, fabricGridId, colourGridId, fabricKey, colourKey) {
        const grid = document.getElementById(fabricGridId);
        if(!grid) return;
        grid.innerHTML = "";
        const filtered = listVisibleFabrics().filter(f => f.type === 'curtain' && f.category === category);
        if(filtered.length === 0) {
            grid.innerHTML = emptyFabricGridMessage(category);
            return;
        }
        filtered.forEach(f => {
            const swatch = buildFabricSwatch(f);
            if(state[fabricKey] && state[fabricKey].name === f.name) {
                swatch.classList.add('selected');
            }
            swatch.onclick = () => {
                if (!fabricHasStockedColour('order', f)) return;
                grid.querySelectorAll('.fabric-swatch').forEach(s => s.classList.remove('selected'));
                swatch.classList.add('selected');
                grid.classList.remove('input-error');
                state[fabricKey] = f;
                renderLayerColourGrid(f, colourGridId, colourKey);
                updateInfoTabs(f.name);
                const colour = defaultColourFor(f, 'order');
                if (colour && isChannelStocked('order', f.name, colour)) {
                    selectLayerColour(f, colour, colourGridId, colourKey);
                } else {
                    state[colourKey] = null;
                    updateProgressBubbles();
                }
            };
            grid.appendChild(swatch);
        });
        if(state[fabricKey]) {
            renderLayerColourGrid(state[fabricKey], colourGridId, colourKey);
        }
    }

    function selectLayerColour(fabricObj, colorName, colourGridId, colourKey) {
        if (!isChannelStocked('order', fabricObj.name, colorName)) return;
        state[colourKey] = colorName;
        markSwatchSelected(document.getElementById(colourGridId), colorName);
        const grid = document.getElementById(colourGridId);
        if (grid) grid.classList.remove('input-error');
        updateFabricVisuals(fabricObj.name, colorName);
        calculatePrice();
        updateProgressBubbles();
        nudgeVizPill();
    }

    function renderLayerColourGrid(fabricObj, colourGridId, colourKey) {
        const grid = document.getElementById(colourGridId);
        if(!grid) return;
        grid.innerHTML = "";
        if(!fabricObj || !fabricObj.colors || fabricObj.colors.length === 0) {
            grid.innerHTML = "<div class='loading-state'>No colours available.</div>";
            return;
        }
        fabricObj.colors.forEach(colorName => {
            const swatch = buildColourSwatch(fabricObj, colorName);
            if(state[colourKey] === colorName) swatch.classList.add('selected');
            swatch.onclick = () => {
                if (!isChannelStocked('order', fabricObj.name, colorName)) return;
                selectLayerColour(fabricObj, colorName, colourGridId, colourKey);
            };
            grid.appendChild(swatch);
        });
    }

    // --- 6. PRICING ENGINE ---
    const VERCEL_HOST = 'https://blind-middleware.vercel.app';
    const PRICE_DEBOUNCE_MS = 350;
    const PRICE_RETRY_DELAYS_MS = [400, 1200];
    let priceRequestId = 0;
    let priceAbortController = null;
    let priceDebounceTimer = null;
    let priceSoftRetryTimer = null;

    function waitForPriceRetry(ms, signal) {
        return new Promise((resolve, reject) => {
            if (signal?.aborted) {
                reject(new DOMException('Aborted', 'AbortError'));
                return;
            }
            const timer = setTimeout(resolve, ms);
            if (!signal) return;
            signal.addEventListener('abort', () => {
                clearTimeout(timer);
                reject(new DOMException('Aborted', 'AbortError'));
            }, { once: true });
        });
    }

    async function parsePriceResponse(response) {
        const text = await response.text();
        if (!text) return {};
        try {
            return JSON.parse(text);
        } catch {
            return {};
        }
    }

    function isRetryablePriceFailure(response) {
        if (!response) return true;
        return response.status === 429 || response.status === 408 || response.status >= 500;
    }

    function cancelPriceLookup() {
        clearTimeout(priceDebounceTimer);
        clearTimeout(priceSoftRetryTimer);
        priceDebounceTimer = null;
        priceSoftRetryTimer = null;
        if (priceAbortController) {
            priceAbortController.abort();
            priceAbortController = null;
        }
        priceRequestId += 1;
    }

    async function fetchPriceByGroup(type, group, width, drop, signal) {
        const query = new URLSearchParams({
            type,
            group: String(resolvePriceGroup(type, group)),
            width: String(width),
            drop: String(drop)
        });
        const url = `${VERCEL_HOST}/api/get-price?${query.toString()}`;
        let lastError = new Error('Pricing lookup failed');

        for (let attempt = 0; attempt <= PRICE_RETRY_DELAYS_MS.length; attempt++) {
            if (attempt > 0) await waitForPriceRetry(PRICE_RETRY_DELAYS_MS[attempt - 1], signal);
            try {
                const response = await fetch(url, { signal, cache: 'no-store' });
                const data = await parsePriceResponse(response);
                if (!response.ok) {
                    const err = new Error(data.error || 'Pricing lookup failed');
                    err.status = response.status;
                    if (isRetryablePriceFailure(response)) {
                        lastError = err;
                        continue;
                    }
                    throw err;
                }
                const price = Number(data.price);
                if (!Number.isFinite(price)) {
                    lastError = new Error('Pricing lookup failed');
                    continue;
                }
                return price;
            } catch (error) {
                if (error?.name === 'AbortError') throw error;
                lastError = error;
            }
        }

        throw lastError;
    }

    async function runPriceLookup(options = {}) {
        if (priceAbortController) priceAbortController.abort();
        const controller = new AbortController();
        priceAbortController = controller;
        const requestId = ++priceRequestId;
        const w = MODE === 'curtain' ? getFinishedTrackWidth(state.width) : state.width;
        const d = state.drop;

        updatePriceDisplay('...', { loading: true });

        try {
            let finalPrice = 0;
            if (isDoubleCurtainMode()) {
                const [sheerPrice, blockoutPrice] = await Promise.all([
                    fetchPriceByGroup('curtain', state.doubleSheerFabric.group, w, d, controller.signal),
                    fetchPriceByGroup('curtain', state.doubleBlockoutFabric.group, w, d, controller.signal)
                ]);
                finalPrice = sheerPrice + blockoutPrice;
            } else {
                finalPrice = await fetchPriceByGroup(MODE, state.fabric.group, w, d, controller.signal);
            }

            if (requestId !== priceRequestId) return;

            if (MODE === 'blind' && state.options.motor === 'Motorised') {
                finalPrice += 130;
            }

            if (requestId !== priceRequestId) return;
            state.price = finalPrice;
            updatePriceDisplay(formatAudPrice(finalPrice));
            clearTimeout(priceSoftRetryTimer);
        } catch (error) {
            if (error?.name === 'AbortError' || requestId !== priceRequestId) return;
            state.price = 0;
            if (error?.status === 400) {
                const limits = getMeasureLimits();
                const msg = String(error.message || '');
                if (/drop/i.test(msg)) {
                    setLimitHelper('drop-limit-text', 'drop', state.drop, limits.minD, limits.maxD, msg);
                    document.getElementById('custom-input-drop')?.closest('.tech-input-wrapper')?.classList.add('input-error');
                } else if (/width/i.test(msg)) {
                    setLimitHelper('width-limit-text', 'width', state.width, limits.minW, limits.maxW, msg);
                    document.getElementById('custom-input-width')?.closest('.tech-input-wrapper')?.classList.add('input-error');
                }
                updatePriceDisplay('Check size');
                return;
            }
            console.error('API Connection Failed', error);
            updatePriceDisplay('Error');
            if (!options.softRetry) {
                clearTimeout(priceSoftRetryTimer);
                priceSoftRetryTimer = setTimeout(() => {
                    if (requestId !== priceRequestId) return;
                    runPriceLookup({ softRetry: true });
                }, 1500);
            }
        }
    }

    window.calculatePrice = function(options = {}) {
        if (MODE === 'sample') return;

        const widthInput = document.getElementById('custom-input-width');
        const dropInput = document.getElementById('custom-input-drop');
        const w = parseInt(widthInput?.value, 10) || 0;
        const d = parseInt(dropInput?.value, 10) || 0;

        state.width = w;
        state.drop = d;
        updateCurtainMeasureCopy();

        const limits = getMeasureLimits();
        const widthOk = w >= limits.minW && w <= limits.maxW;
        const dropOk = d >= limits.minD && d <= limits.maxD;
        const widthWrap = widthInput?.closest('.tech-input-wrapper');
        const dropWrap = dropInput?.closest('.tech-input-wrapper');
        if (w > 0 && widthOk) widthWrap?.classList.remove('input-error');
        else if (w > 0) widthWrap?.classList.add('input-error');
        if (d > 0 && dropOk) dropWrap?.classList.remove('input-error');
        else if (d > 0) dropWrap?.classList.add('input-error');
        updateLimitHelpers();

        updateProgressBubbles();

        const missingSingle = !state.fabric;
        const missingDouble = isDoubleCurtainMode() && (!state.doubleSheerFabric || !state.doubleBlockoutFabric || !state.doubleSheerColour || !state.doubleBlockoutColour);
        const measuresReady = widthOk && dropOk && (MODE !== 'curtain' || !!state.options.wallToWall);
        if ((missingSingle && !isDoubleCurtainMode()) || missingDouble || !measuresReady) {
            cancelPriceLookup();
            resetPriceDisplay();
            return;
        }

        if (!options.immediate) {
            clearTimeout(priceDebounceTimer);
            priceDebounceTimer = setTimeout(() => window.calculatePrice({ immediate: true }), PRICE_DEBOUNCE_MS);
            return;
        }

        runPriceLookup();
    };

    const MASTER_ATC_LABEL_DEFAULT = 'Add to Cart';

    function normalizeCartReference(ref) {
        return String(ref || '').trim().toLowerCase();
    }

    function sortedOptionsForSignature(options) {
        const sorted = {};
        Object.keys(options || {}).sort().forEach((key) => {
            sorted[key] = options[key];
        });
        return sorted;
    }

    function getCartItemConfigSignature(item) {
        if (!item || item.product_type === 'sample') return null;
        return JSON.stringify({
            product_type: item.product_type,
            width: item.width,
            drop: item.drop,
            fabric: item.fabric,
            colour: item.colour,
            category: item.category,
            group: item.group,
            curtain_layer_mode: item.curtain_layer_mode || null,
            measured_width: item.measured_width ?? null,
            wall_to_wall_deduction_mm: item.wall_to_wall_deduction_mm ?? null,
            sheer: item.sheer || null,
            blockout: item.blockout || null,
            options: sortedOptionsForSignature(item.options)
        });
    }

    function buildPendingCartItemFromState() {
        const item = {
            id: Date.now(),
            product_type: MODE,
            width: MODE === 'curtain' ? getFinishedTrackWidth(state.width) : state.width,
            drop: state.drop,
            fabric: state.fabric?.name || null,
            colour: state.colour || null,
            category: state.fabric?.category || null,
            group: resolvePriceGroup(MODE, state.fabric?.group) || null,
            price: state.price || 0,
            options: state.options,
            reference: getReferenceNameInput()?.value || ''
        };

        if (MODE === 'curtain') {
            item.measured_width = state.width;
            if (isWallToWall()) {
                item.wall_to_wall_deduction_mm = WALL_TO_WALL_DEDUCT_MM;
            }
        }

        if (isDoubleCurtainMode()) {
            item.curtain_layer_mode = 'double';
            item.sheer = {
                fabric: state.doubleSheerFabric?.name || null,
                colour: state.doubleSheerColour || null,
                group: resolvePriceGroup('curtain', state.doubleSheerFabric?.group) || null
            };
            item.blockout = {
                fabric: state.doubleBlockoutFabric?.name || null,
                colour: state.doubleBlockoutColour || null,
                group: resolvePriceGroup('curtain', state.doubleBlockoutFabric?.group) || null
            };
            item.fabric = `${item.sheer.fabric || 'Sheer'} + ${item.blockout.fabric || 'Blockout'}`;
            item.colour = `${item.sheer.colour || '-'} + ${item.blockout.colour || '-'}`;
        }

        return item;
    }

    function readVirtualCartForConfigurator() {
        try {
            const cart = JSON.parse(localStorage.getItem('virtual_cart') || '[]');
            return Array.isArray(cart) ? cart : [];
        } catch (e) {
            return [];
        }
    }

    function isPendingItemAlreadyInCart(pendingItem) {
        const item = pendingItem || buildPendingCartItemFromState();
        const signature = getCartItemConfigSignature(item);
        const reference = normalizeCartReference(item.reference);
        if (!signature) return false;

        return readVirtualCartForConfigurator().some((existing) => {
            if (!existing || existing.product_type === 'sample') return false;
            if (getCartItemConfigSignature(existing) !== signature) return false;
            return normalizeCartReference(existing.reference) === reference;
        });
    }

    function getMasterAtcLabelEl() {
        const btn = document.getElementById('master-atc-btn');
        return btn ? (btn.querySelector('span') || btn) : null;
    }

    function syncAtcDuplicateState() {
        if (MODE === 'sample') return;
        const configReady = typeof isConfigurationComplete === 'function' && isConfigurationComplete();
        const duplicate = configReady && isPendingItemAlreadyInCart();
        const masterAtc = document.getElementById('master-atc-btn');
        const label = getMasterAtcLabelEl();

        if (masterAtc) {
            masterAtc.disabled = !configReady || duplicate;
            masterAtc.classList.toggle('cfg-atc-btn--disabled', duplicate);
            if (label) {
                label.textContent = duplicate ? 'Already in cart' : MASTER_ATC_LABEL_DEFAULT;
            }
        }

        document.querySelectorAll('.cfg-step[data-step="4"] [data-step-continue]').forEach((cont) => {
            cont.textContent = duplicate ? 'Already in cart' : 'Add to cart';
            cont.disabled = !isStepDone(4) || duplicate;
        });
    }

    // --- 7. ADD TO CART (blind/curtain only; sample page uses its own sticky bar) ---
    const atcBtn = (MODE !== 'sample') ? document.getElementById('master-atc-btn') : null;
    if(atcBtn) {
        atcBtn.addEventListener('click', function() {
            if(atcBtn.classList.contains('loading')) return;
            if(!validateSelection()) return;

            const item = buildPendingCartItemFromState();
            if (isPendingItemAlreadyInCart(item)) {
                syncAtcDuplicateState();
                return;
            }

            atcBtn.classList.add('loading');

            let cart = readVirtualCartForConfigurator();
            cart.push(item);
            localStorage.setItem('virtual_cart', JSON.stringify(cart));

            setTimeout(() => {
                atcBtn.classList.remove('loading');
                triggerSuccessModal();
                syncAtcDuplicateState();
                window.dispatchEvent(new Event('storage')); 
            }, 600);
        });

        window.addEventListener('storage', syncAtcDuplicateState);
    }

    // --- 8. UTILS ---
    function updateVisualizer(url) {
        const fabricLayer = document.getElementById('fabric-layer');
        const phText = document.getElementById('placeholder-text');
        const loader = document.getElementById('visualizer-loading');
        
        if (fabricLayer && url) {
            if(loader) loader.classList.add('active');

            const cleanUrl = url.replace(/^url\(['"]?/, '').replace(/['"]?\)$/, '');
            
            const tempImg = new Image();
            tempImg.src = cleanUrl;
            
            tempImg.onload = function() {
                fabricLayer.style.backgroundImage = `url('${cleanUrl}')`;
                // Curtains: leave sizing to CSS (200px tile + repeat).
                // Inline cover/no-repeat caused a floating centered square
                // because overlay-* CDN assets are flat textures, not scenes.
                if (MODE === 'curtain') {
                    fabricLayer.style.backgroundRepeat = '';
                    fabricLayer.style.backgroundSize = '';
                    fabricLayer.style.backgroundPosition = '';
                }
                
                if(phText) phText.style.display = 'none';
                
                if(loader) loader.classList.remove('active');
            };
            
            tempImg.onerror = function() {
                if(loader) loader.classList.remove('active');
            };
        }
    }

    let activeFabricPreviewSlot = 'scene';
    let fabricPreviewUrls = null;
    let fabricPreviewAltBase = '';

    const FABRIC_PREVIEW_SLOTS = [
        { slot: 'scene', type: 'overlay', altSuffix: 'room view' },
        { slot: 'detail1', type: 'detail1', altSuffix: 'texture' },
        { slot: 'detail2', type: 'detail2', altSuffix: 'weave' },
        { slot: 'detail3', type: 'detail3', altSuffix: 'lay flat' }
    ];

    function bindFabricThumbGrid() {
        const grid = document.getElementById('fabric-thumb-grid');
        if (!grid || grid.dataset.bound === 'true') return;
        grid.dataset.bound = 'true';
        grid.querySelectorAll('.fabric-thumb').forEach(btn => {
            btn.addEventListener('click', () => {
                const slot = btn.getAttribute('data-preview-slot');
                if (slot) setFabricPreviewSlot(slot);
            });
        });
    }

    function setFabricPreviewSlot(slot) {
        if ((MODE !== 'curtain' && MODE !== 'blind') || !fabricPreviewUrls) return;
        activeFabricPreviewSlot = slot;

        const flatPreview = document.getElementById('fabric-flat-preview');
        const grid = document.getElementById('fabric-thumb-grid');
        const stage = document.getElementById('fabric-preview-stage');
        const isDetail = slot !== 'scene';

        grid?.querySelectorAll('.fabric-thumb').forEach(btn => {
            btn.classList.toggle('is-active', btn.getAttribute('data-preview-slot') === slot);
        });
        stage?.classList.toggle('is-detail-view', isDetail);

        // Scene stays in the layout to hold height. Detail views hide it
        // and fill the same box so the room does not show through.
        if (!isDetail) {
            if (flatPreview) {
                flatPreview.hidden = true;
                flatPreview.removeAttribute('src');
                flatPreview.removeAttribute('alt');
            }
            return;
        }

        const url = fabricPreviewUrls[slot];
        if (!url || !flatPreview) return;
        flatPreview.src = url;
        flatPreview.alt = fabricImageAlt(fabricPreviewAltBase, '', 'detail preview');
        flatPreview.hidden = false;
    }

    function syncThumbStrip() {
        const grid = document.getElementById('fabric-thumb-grid');
        if (!grid) return;
        const visible = [...grid.querySelectorAll('.fabric-thumb')].filter((btn) => !btn.hidden).length;
        const hideStrip = visible < 2;
        const changed = grid.hidden !== hideStrip;
        grid.hidden = hideStrip;
        if (changed && vizEngine) {
            requestAnimationFrame(() => {
                if (vizEngine) vizEngine.resize();
            });
        }
    }

    function syncDetailThumbVisibility(img) {
        const btn = img?.closest('.fabric-thumb');
        if (!btn || btn.getAttribute('data-preview-slot') === 'scene') return;
        const hide = () => {
            btn.hidden = true;
            syncThumbStrip();
        };
        const reveal = () => {
            if (!img.complete) return;
            btn.hidden = img.naturalWidth === 0;
            syncThumbStrip();
        };
        img.onload = reveal;
        img.onerror = hide;
        if (img.complete) reveal();
    }

    function waitForRoomPhoto(img, timeoutMs = 2000) {
        if (!img) return Promise.resolve();
        if (img.complete && img.naturalWidth > 0) return Promise.resolve();
        return new Promise((resolve) => {
            const timer = setTimeout(resolve, timeoutMs);
            const finish = () => {
                clearTimeout(timer);
                resolve();
            };
            img.addEventListener('load', finish, { once: true });
            img.addEventListener('error', finish, { once: true });
        });
    }

    function updateFabricThumbGrid(fabricName, colourName) {
        const grid = document.getElementById('fabric-thumb-grid');
        if (!grid || (MODE !== 'curtain' && MODE !== 'blind')) return;

        bindFabricThumbGrid();

        fabricPreviewAltBase = `${fabricName} ${colourName}`.trim();
        fabricPreviewUrls = {};
        FABRIC_PREVIEW_SLOTS.forEach(({ slot, type, altSuffix }) => {
            const url = getUrl(type, fabricName, colourName);
            fabricPreviewUrls[slot] = url;
            const img = grid.querySelector(`[data-thumb-role="${slot}"]`);
            if (img) {
                const btn = img.closest('.fabric-thumb');
                if (slot === 'scene') {
                    if (btn) btn.hidden = false;
                } else if (btn) {
                    btn.hidden = true;
                }
                img.src = url;
                img.alt = fabricImageAlt(fabricName, colourName, altSuffix);
                syncDetailThumbVisibility(img);
            }
        });

        syncThumbStrip();
        setFabricPreviewSlot('scene');
        syncVizPillThumb();
    }

    function clearFabricVisuals() {
        const fabricLayer = document.getElementById('fabric-layer');
        const phText = document.getElementById('placeholder-text');
        const thumbGrid = document.getElementById('fabric-thumb-grid');
        const flatPreview = document.getElementById('fabric-flat-preview');

        fabricPreviewUrls = null;
        fabricPreviewAltBase = '';
        activeFabricPreviewSlot = 'scene';

        if (fabricLayer) fabricLayer.style.backgroundImage = '';
        if (phText) phText.style.display = '';
        if (flatPreview) {
            flatPreview.hidden = true;
            flatPreview.removeAttribute('src');
            flatPreview.removeAttribute('alt');
        }
        document.getElementById('fabric-preview-stage')?.classList.remove('is-detail-view');
        if (thumbGrid) {
            thumbGrid.hidden = true;
            thumbGrid.querySelectorAll('img').forEach(img => {
                img.removeAttribute('src');
                img.removeAttribute('alt');
            });
            thumbGrid.querySelectorAll('.fabric-thumb').forEach(btn => {
                btn.classList.toggle('is-active', btn.getAttribute('data-preview-slot') === 'scene');
                if (btn.getAttribute('data-preview-slot') !== 'scene') {
                    btn.hidden = false;
                }
            });
        }
        if (vizEngine) vizEngine.clear();
    }

    let vizEngine = null;
    let vizInitPromise = null;
    const USE_CANVAS_VIZ = (window.__visualizerEngine || 'canvas') !== 'legacy'
        && (MODE === 'blind' || MODE === 'curtain');

    function isVizDrawerOpen() {
        const drawer = document.getElementById('cfg-viz-drawer');
        return !!(drawer && !drawer.hidden);
    }

    function hydrateDeferredImages(root) {
        if (!root) return;
        root.querySelectorAll('img[data-src]').forEach((img) => {
            if (USE_CANVAS_VIZ && (img.classList.contains('highlight-layer') || img.classList.contains('roll-layer') || img.classList.contains('floor-layer'))) {
                return;
            }
            const src = img.dataset.src;
            if (src && img.getAttribute('src') !== src) img.src = src;
        });
    }

    function vizAlbedoUrl(fabric, colour) {
        const url = getUrl('overlay', fabric, colour);
        if (!url || url.indexOf('cdn.shopify.com') === -1) return url;
        if (/[?&]width=/.test(url)) return url;
        return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=560';
    }

    function prefetchVizAlbedo(fabricObj) {
        if (!(MODE === 'blind' && window.__BYBVizLab === 'blind')) return;
        if (!fabricObj || !fabricObj.colors) return;
        const load = window.BYBVisualizer && window.BYBVisualizer.loadImage;
        fabricObj.colors.forEach((colorName) => {
            const url = vizAlbedoUrl(fabricObj.name, colorName);
            if (!url) return;
            if (load) {
                load(url, 6000).catch(() => {});
            } else {
                const img = new Image();
                img.crossOrigin = 'anonymous';
                img.src = url;
            }
        });
    }

    function scheduleVisualizerRefresh() {
        if (!isVizDrawerOpen()) return;
        const stage = document.getElementById('fabric-preview-stage');
        const loader = document.getElementById('visualizer-loading');
        stage?.classList.add('is-viz-loading');
        loader?.classList.add('active');
        clearTimeout(scheduleVisualizerRefresh._t);
        scheduleVisualizerRefresh._t = setTimeout(() => { refreshVisualizer(); }, 40);
    }

    function getBlindAlbedoUrl(fabric, colour) {
        return vizAlbedoUrl(fabric, colour);
    }

    function buildVizState() {
        const double = isDoubleCurtainMode();
        const albedoFn = (MODE === 'blind' && window.__BYBVizLab === 'blind')
            ? getBlindAlbedoUrl
            : (fabric, colour) => getUrl('overlay', fabric, colour);
        return {
            fabric: state.fabric?.name || null,
            colour: state.colour || null,
            albedoUrl: (!double && state.fabric && state.colour)
                ? albedoFn(state.fabric.name, state.colour)
                : null,
            options: Object.assign({}, state.options),
            mount: state.options.mount_blind || state.options.mount_curtain || null,
            stack: state.options.stack || 'Centre Opening',
            material: state.materialFilter,
            double,
            sheerFabric: state.doubleSheerFabric?.name || null,
            sheerColour: state.doubleSheerColour || null,
            blockoutFabric: state.doubleBlockoutFabric?.name || null,
            blockoutColour: state.doubleBlockoutColour || null,
            sheerAlbedoUrl: (state.doubleSheerFabric && state.doubleSheerColour)
                ? getUrl('overlay', state.doubleSheerFabric.name, state.doubleSheerColour)
                : null,
            blockoutAlbedoUrl: (state.doubleBlockoutFabric && state.doubleBlockoutColour)
                ? getUrl('overlay', state.doubleBlockoutFabric.name, state.doubleBlockoutColour)
                : null,
            thumbUrls: (!double && state.fabric && state.colour)
                ? FABRIC_PREVIEW_SLOTS.map(({ type }) => getUrl(type, state.fabric.name, state.colour)).filter(Boolean)
                : []
        };
    }

    function enableLegacyVisualizer() {
        window.__visualizerEngine = 'legacy';
        const stage = document.getElementById('fabric-preview-stage');
        stage?.classList.remove('viz-engine-canvas');
        stage?.classList.add('viz-engine-legacy');
        const canvas = document.getElementById('viz-fabric-canvas');
        if (canvas) canvas.hidden = true;
        document.getElementById('fabric-layer')?.style.removeProperty('display');
        if (vizEngine) vizEngine.setEngineVisible(false);
        vizEngine = null;
    }

    async function ensureVisualizer() {
        if (!USE_CANVAS_VIZ) return null;
        if (vizEngine) return vizEngine;
        if (vizInitPromise) return vizInitPromise;
        if (!window.BYBVisualizer?.createVisualizer) {
            enableLegacyVisualizer();
            return null;
        }
        vizInitPromise = window.BYBVisualizer.createVisualizer({
            mode: MODE,
            stage: document.getElementById('fabric-preview-stage'),
            canvas: document.getElementById('viz-fabric-canvas'),
            bgEl: document.getElementById('viz-room-bg'),
            hardwareEl: document.getElementById('viz-hardware'),
            foldEl: document.getElementById('viz-fold'),
            floorEl: document.getElementById('viz-floor'),
            legacyRoot: document.getElementById('blind-visualizer'),
            manifestUrl: window.__visualizerManifestUrl,
            getAlbedoUrl: (fabric, colour) => {
                if (MODE === 'blind' && window.__BYBVizLab === 'blind') return vizAlbedoUrl(fabric, colour);
                return getUrl('overlay', fabric, colour);
            }
        }).then((engine) => {
            vizEngine = engine;
            if (window.__BYBVizLab) window.__BYBVizEngine = engine;
            return engine;
        }).catch((err) => {
            console.warn('[configurator] Canvas visualizer failed; using legacy', err);
            enableLegacyVisualizer();
            return null;
        });
        return vizInitPromise;
    }

    let vizRefreshGen = 0;

    async function refreshVisualizer() {
        if (!isVizDrawerOpen()) return;
        const phText = document.getElementById('placeholder-text');
        const stage = document.getElementById('fabric-preview-stage');
        const loader = document.getElementById('visualizer-loading');
        const gen = ++vizRefreshGen;
        stage?.classList.add('is-viz-loading');
        loader?.classList.add('active');
        const engine = await ensureVisualizer();
        if (!engine) {
            // Legacy path: single fabric only
            if (state.fabric && state.colour) {
                updateVisualizer(getUrl('overlay', state.fabric.name, state.colour));
            }
            if (gen === vizRefreshGen) {
                stage?.classList.remove('is-viz-loading');
                loader?.classList.remove('active');
            }
            return;
        }
        try {
            await engine.render(buildVizState());
            if (phText) phText.style.display = 'none';
        } catch (err) {
            console.warn('[configurator] Render failed; falling back', err);
            if (window.__BYBVizLab) return;
            enableLegacyVisualizer();
            if (state.fabric && state.colour) {
                updateVisualizer(getUrl('overlay', state.fabric.name, state.colour));
            }
        } finally {
            if (gen === vizRefreshGen) {
                stage?.classList.remove('is-viz-loading');
                loader?.classList.remove('active');
            }
        }
    }

    function updateFabricVisuals(fabricName, colourName) {
        if (!fabricName || !colourName) {
            if (!isDoubleCurtainMode()) {
                clearFabricVisuals();
                syncVizPillThumb();
                return;
            }
        }
        if (isVizDrawerOpen()) {
            if (fabricName && colourName) {
                updateFabricThumbGrid(fabricName, colourName);
                const phText = document.getElementById('placeholder-text');
                if (phText) phText.style.display = 'none';
            } else if (isDoubleCurtainMode() && state.doubleSheerFabric && state.doubleSheerColour) {
                updateFabricThumbGrid(state.doubleSheerFabric.name, state.doubleSheerColour);
            }
            scheduleVisualizerRefresh();
        } else {
            syncVizPillThumb();
        }
    }

    function validateSelection() {
        let valid = true;
        let firstError = null;

        clearValidationErrors();

        // --- 0. REFERENCE NAME (first field in form) ---
        if (MODE !== 'sample') {
            const nameInput = getReferenceNameInput();
            if (nameInput && !nameInput.value.trim()) {
                setReferenceNameError(true);
                firstError = nameInput.closest('.cfg-window-name') || nameInput.closest('.cfg-reference') || nameInput;
                valid = false;
            }
        }

        // --- 1. FABRIC & COLOUR CHECKS ---
        if(isDoubleCurtainMode()) {
            const checks = [
                { ok: !!state.doubleSheerFabric, id: 'double-sheer-fabric-grid' },
                { ok: !!state.doubleSheerColour, id: 'double-sheer-colour-grid' },
                { ok: !!state.doubleBlockoutFabric, id: 'double-blockout-fabric-grid' },
                { ok: !!state.doubleBlockoutColour, id: 'double-blockout-colour-grid' }
            ];
            checks.forEach(c => {
                if(!c.ok) {
                    const el = document.getElementById(c.id);
                    if(el) {
                        el.classList.add('input-error');
                        if(!firstError) firstError = el;
                    }
                    valid = false;
                }
            });
            const layerStock = [
                { fabric: state.doubleSheerFabric, colour: state.doubleSheerColour, id: 'double-sheer-colour-grid' },
                { fabric: state.doubleBlockoutFabric, colour: state.doubleBlockoutColour, id: 'double-blockout-colour-grid' }
            ];
            layerStock.forEach(layer => {
                if (layer.fabric && layer.colour && !isChannelStocked('order', layer.fabric.name, layer.colour)) {
                    const el = document.getElementById(layer.id);
                    if (el) {
                        el.classList.add('input-error');
                        if (!firstError) firstError = el;
                    }
                    valid = false;
                }
            });
        } else {
            if(!state.fabric) { 
                const el = document.getElementById(MODE==='sample'?'sample-fabric-grid':'fabric-grid');
                el.classList.add('input-error'); 
                if(!firstError) firstError = el;
                valid = false; 
            }
            
            if(state.fabric && !state.colour) {
                 const el = document.getElementById(MODE==='sample'?'sample-colour-grid':'colour-grid');
                 el.classList.add('input-error');
                 if(!firstError) firstError = el;
                 valid = false;
            }

            if (MODE !== 'sample' && state.fabric && state.colour && !isChannelStocked('order', state.fabric.name, state.colour)) {
                const el = document.getElementById('colour-grid');
                if (el) {
                    el.classList.add('input-error');
                    if(!firstError) firstError = el;
                }
                valid = false;
            }
        }
        
        // --- 2. PRODUCT SPECIFIC CHECKS ---
        if(MODE !== 'sample') {
            // --- REPLACED: MEASUREMENT VALIDATION ---
            const widthInput = document.getElementById('custom-input-width');
            const dropInput = document.getElementById('custom-input-drop');
            const wWrapper = widthInput.closest('.tech-input-wrapper');
            const dWrapper = dropInput.closest('.tech-input-wrapper');

            const limits = getMeasureLimits();

            // Validate Width
            if (state.width < limits.minW || state.width > limits.maxW) {
                wWrapper.classList.add('input-error');
                if (!firstError) firstError = widthInput;
                valid = false;
            }

            // Validate Drop
            if (state.drop < limits.minD || state.drop > limits.maxD) {
                dWrapper.classList.add('input-error');
                if (!firstError) firstError = dropInput;
                valid = false;
            }
            // ----------------------------------------

            // --- IMPROVED CHECK RADIO HELPER ---
            const checkRadio = (key, containerId) => {
                if(!state.options[key]) {
                    let el = document.getElementById(containerId);
                    
                    if(el) {
                        el.classList.add('input-error');
                        // Highlight the Label (if found)
                        const labelGroup = el.closest('.ind-form-group');
                        if(labelGroup) {
                             const label = labelGroup.querySelector('.ind-label');
                             if(label) label.classList.add('text-error');
                        }
                        
                        // Set Scroll Target
                        if(!firstError) firstError = el;
                    }
                    valid = false;
                }
            };

            if(MODE === 'blind') {
                // Standard Options
                checkRadio('mount_blind', 'mount-options-container');
                checkRadio('control', 'control-options-container');
                checkRadio('roll', 'roll-options-container');
                checkRadio('bracket', 'bracket-options-container');
                
                // RE-ENABLED: Force the user to select 'Chain' to ensure state is set
                checkRadio('motor', 'motor-options-container');
                
                // Always require Chain Type
                checkRadio('chain', 'chain-options-container');

                checkRadio('baseShape', 'base-shape-container');
                checkRadio('baseColour', 'base-colour-container');
            } 
            else if (MODE === 'curtain') {
                checkRadio('wallToWall', 'wall-to-wall-container');
                checkRadio('mount_curtain', 'mount-options-container');
                if (isDoubleCurtainMode()) {
                    state.options.bracketType_curtain = 'Double bracket';
                } else if (state.options.mount_curtain === 'Face Fit') {
                    checkRadio('bracketType_curtain', 'bracket-type-curtain-container');
                }
                checkRadio('stack', 'stack-options-container');
                checkRadio('wand', 'wand-options-container');
                checkRadio('trackColour', 'track-colour-container');
                checkRadio('hemFinish', 'hem-options-container');
            }
        }
        
        // --- 3. SCROLL TO ERROR ---
        if(!valid && firstError) {
            firstError.scrollIntoView({behavior:'smooth', block:'center'});
        }
        
        return valid;
    }

    function updateInfoTabs(fabricName) {
        // 1. Get the data using the New Brand Name
        const specs = FABRIC_SPECS[fabricName];
        
        // Safety check: if no data found, do nothing (or log it)
        if (!specs) {
            console.warn("No specs found for:", fabricName);
            return; 
        }

        // 2. Direct Replacement of Inner HTML
        // This overwrites the existing <p> tags with new ones
        const d = document.getElementById('desc');
        const f = document.getElementById('feat');
        const i = document.getElementById('inc');

        if(d) d.innerHTML = `<p>${specs.desc}</p>`;
        // Matches the 'features' key in your FABRIC_SPECS
        if(f) f.innerHTML = `<p>${specs.features}</p>`; 

        // Matches the 'included' key in your FABRIC_SPECS
        if(i) i.innerHTML = `<p>${specs.included}</p>`;
    }

    function updateProgressBubbles() {
        if(MODE === 'sample') return;
        const set = (id, ok) => {
            const el = document.getElementById(id);
            if(el) { if(ok) el.classList.add('completed'); else el.classList.remove('completed'); }
        };
        
        if(isDoubleCurtainMode()) {
            set('bub-fabric', false);
            set('bub-colour', false);
            set('bub-sheer-fabric', !!state.doubleSheerFabric);
            set('bub-sheer-colour', !!state.doubleSheerColour);
            set('bub-blockout-fabric', !!state.doubleBlockoutFabric);
            set('bub-blockout-colour', !!state.doubleBlockoutColour);
        } else {
            set('bub-fabric', !!state.fabric);
            set('bub-colour', !!state.colour);
            set('bub-sheer-fabric', false);
            set('bub-sheer-colour', false);
            set('bub-blockout-fabric', false);
            set('bub-blockout-colour', false);
        }
        
        const nameVal = MODE === 'blind' ? document.getElementById('custom-input-name-b')?.value : document.getElementById('custom-input-name-c')?.value;
        set('bub-name', nameVal && nameVal.trim().length > 0);

        const measureLimits = getMeasureLimits();
        set('bub-measure',
            state.width >= measureLimits.minW && state.width <= measureLimits.maxW &&
            state.drop >= measureLimits.minD && state.drop <= measureLimits.maxD &&
            (MODE !== 'curtain' || !!state.options.wallToWall)
        );
        
        // Progress Bubble logic based on MODE
        if(MODE === 'blind') {
            set('bub-mount', !!state.options.mount_blind);
            set('bub-control', !!state.options.control);
            set('bub-roll', !!state.options.roll);
            set('bub-bracket', !!state.options.bracket);
            // set('bub-motor', !!state.options.motor);
            set('bub-chain', !!state.options.chain);
            set('bub-base-shape', !!state.options.baseShape);
            set('bub-base-colour', !!state.options.baseColour);
        } else {
            set('bub-mount', !!state.options.mount_curtain);
            set('bub-wall-to-wall', !!state.options.wallToWall);
            if(isDoubleCurtainMode()) {
                set('bub-bracket-type-curtain', true);
            } else {
                set('bub-bracket-type-curtain', state.options.mount_curtain !== 'Face Fit' || !!state.options.bracketType_curtain);
            }
            set('bub-stack', !!state.options.stack);
            set('bub-wand', !!state.options.wand);
            set('bub-track-colour', !!state.options.trackColour);
            set('bub-hem', !!state.options.hemFinish);
        }

        // Drive the new sidebar summary + step accordion locks + price mirror
        if(typeof refreshCfgUI === 'function') refreshCfgUI();
    }

    // --- GLOBAL HANDLERS ---

    /* ============================================================
       SAMPLE PAGE ENGINE (flat, filterable, multi-select)
       ============================================================
       The blind/curtain configurator keeps its fabric->colour data
       shape (needed for pricing + visualiser). For the sample page
       we derive a flat list of (type, fabric, colour, category)
       records from CONSTANTS.fabrics and drive the UI from that.
    ============================================================ */
    const sampleState = {
        type: 'all',            // 'all' | 'blind' | 'curtain'
        category: 'all',        // 'all' | 'Blockout' | 'Light Filtering' | 'Screen' | 'Sheer'
        selected: new Set(),    // sample IDs
        maxSamples: 6,          // keep in sync with virtual-cart.js MAX_FREE_SAMPLES
        all: []
    };

    function sampleId(type, fabric, category, colour) {
        return `${type}::${fabric}::${category}::${colour}`;
    }

    function buildFlatSampleList() {
        const list = [];
        listVisibleFabrics().forEach(f => {
            (f.colors || []).forEach(c => {
                list.push({
                    id: sampleId(f.type, f.name, f.category, c),
                    type: f.type,
                    fabric: f.name,
                    colour: c,
                    category: f.category,
                    group: f.group,
                    available: isChannelStocked('sample', f.name, c)
                });
            });
        });
        return list;
    }

    // Some fabrics (e.g. Haven) share a name across categories and the
    // existing getUrl() reads state.materialFilter to disambiguate.
    // Temporarily swap it so we get the correct swatch per sample.
    function imageForSample(s) {
        const prev = state.materialFilter;
        state.materialFilter = s.category;
        const url = getUrl('swatch', s.fabric, s.colour);
        state.materialFilter = prev;
        return url;
    }

    function availableCategoriesForType(type) {
        const set = new Set();
        sampleState.all.forEach(s => {
            if(type === 'all' || s.type === type) set.add(s.category);
        });
        // Preserve a sensible order
        const order = ['Blockout', 'Light Filtering', 'Screen', 'Sheer'];
        return order.filter(c => set.has(c));
    }

    function renderSampleFilterPills() {
        const wrap = document.getElementById('sp-filter-pills');
        if(!wrap) return;
        const cats = availableCategoriesForType(sampleState.type);
        const pills = [
            `<button class="sp-filter-pill ${sampleState.category === 'all' ? 'active' : ''}" data-category="all">All</button>`
        ].concat(
            cats.map(c => `<button class="sp-filter-pill ${sampleState.category === c ? 'active' : ''}" data-category="${c}">${c}</button>`)
        );
        wrap.innerHTML = pills.join('');
        wrap.querySelectorAll('.sp-filter-pill').forEach(btn => {
            btn.addEventListener('click', () => {
                sampleState.category = btn.dataset.category;
                wrap.querySelectorAll('.sp-filter-pill').forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                renderSampleGrid();
            });
        });
    }

    function filteredSamples() {
        return sampleState.all.filter(s => {
            if(sampleState.type !== 'all' && s.type !== sampleState.type) return false;
            if(sampleState.category !== 'all' && s.category !== sampleState.category) return false;
            return true;
        });
    }

    function renderSampleGrid() {
        const grid = document.getElementById('sp-grid');
        const empty = document.getElementById('sp-empty');
        if(!grid) return;
        const items = filteredSamples();
        if(items.length === 0) {
            grid.innerHTML = '';
            if(empty) empty.style.display = 'block';
            return;
        }
        if(empty) empty.style.display = 'none';

        const atLimit = isAtSampleLimit();
        const html = items.map(s => {
            const isOos = s.available === false;
            const isSelected = !isOos && sampleState.selected.has(s.id);
            const isLocked = !isOos && atLimit && !isSelected;
            const img = imageForSample(s);
            const typeTag = s.type === 'blind' ? 'Blind' : 'Curtain';
            const cardClass = [
                'sp-card',
                isSelected ? 'selected' : '',
                isLocked ? 'sp-card--locked' : '',
                isOos ? 'sp-card--oos' : ''
            ].filter(Boolean).join(' ');
            const addControl = isOos
                ? '<span class="sp-card-oos-badge">Out of stock</span>'
                : `<button class="sp-card-add" type="button" aria-label="${isSelected ? 'Remove sample' : (isLocked ? 'Sample limit reached' : 'Add sample')}">
                            ${isSelected
                                ? '<svg viewBox="0 0 24 24"><path d="M5 12l5 5L20 7"/></svg>'
                                : '<svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>'}
                        </button>`;
            return `
                <article class="${cardClass}" data-id="${s.id}" ${isOos ? 'aria-disabled="true"' : `tabindex="0" role="button" aria-pressed="${isSelected}" ${isLocked ? 'aria-disabled="true"' : ''}`}>
                    <div class="sp-card-image" style="background-image:url('${img}')">
                        <span class="sp-card-type-tag">${typeTag} · ${s.category}</span>
                        ${addControl}
                    </div>
                    <div class="sp-card-body">
                        <span class="sp-card-fabric">${s.fabric}</span>
                        <span class="sp-card-colour">${s.colour}</span>
                        <span class="sp-card-category">${typeTag} · ${s.category}</span>
                    </div>
                </article>
            `;
        }).join('');
        grid.innerHTML = html;

        grid.querySelectorAll('.sp-card:not(.sp-card--oos)').forEach(card => {
            const id = card.dataset.id;
            const toggle = (e) => {
                e.preventDefault();
                e.stopPropagation();
                toggleSample(id, card);
            };
            card.addEventListener('click', toggle);
            card.addEventListener('keydown', (e) => {
                if(e.key === 'Enter' || e.key === ' ') toggle(e);
            });
        });
    }

    function cartSampleCount() {
        try {
            const cart = JSON.parse(localStorage.getItem('virtual_cart') || '[]');
            return cart.filter(i => i && i.product_type === 'sample' && isChannelStocked('sample', i.fabric, i.colour)).length;
        } catch (e) {
            return 0;
        }
    }

    function totalSampleCount() {
        return sampleState.selected.size + cartSampleCount();
    }

    function isAtSampleLimit() {
        return totalSampleCount() >= sampleState.maxSamples;
    }

    function syncSampleLimitUi() {
        const atLimit = isAtSampleLimit();
        const bar = document.getElementById('sp-sticky-bar');
        const grid = document.getElementById('sp-grid');
        if(bar) bar.classList.toggle('is-maxed', atLimit);
        if(!grid) return;
        grid.classList.toggle('is-maxed', atLimit);
        grid.querySelectorAll('.sp-card').forEach(card => {
            if (card.classList.contains('sp-card--oos')) return;
            const selected = sampleState.selected.has(card.dataset.id);
            const locked = atLimit && !selected;
            card.classList.toggle('sp-card--locked', locked);
            if(locked) card.setAttribute('aria-disabled', 'true');
            else card.removeAttribute('aria-disabled');
            const addBtn = card.querySelector('.sp-card-add');
            if(addBtn && !selected) {
                addBtn.setAttribute('aria-label', locked ? 'Sample limit reached' : 'Add sample');
            }
        });
    }

    function toggleSample(id, cardEl) {
        if (cardEl && cardEl.classList.contains('sp-card--oos')) return;
        const rec = sampleState.all.find(s => s.id === id);
        if (rec && rec.available === false) return;
        if(sampleState.selected.has(id)) {
            sampleState.selected.delete(id);
        } else {
            if(isAtSampleLimit()) {
                flashLimitReached();
                return;
            }
            sampleState.selected.add(id);
        }
        // Just update this card in place (avoid full re-render / lost scroll)
        if(cardEl) {
            const selected = sampleState.selected.has(id);
            cardEl.classList.toggle('selected', selected);
            cardEl.setAttribute('aria-pressed', String(selected));
            const addBtn = cardEl.querySelector('.sp-card-add');
            if(addBtn) {
                addBtn.setAttribute('aria-label', selected ? 'Remove sample' : 'Add sample');
                addBtn.innerHTML = selected
                    ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 7"/></svg>'
                    : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>';
            }
        }
        updateSampleProgress();
    }

    function flashLimitReached() {
        const bar = document.getElementById('sp-sticky-bar');
        const countEl = document.getElementById('sp-count');
        const toast = document.getElementById('sp-limit-toast');
        if(countEl) {
            countEl.classList.add('sp-count--flash');
            setTimeout(() => { countEl.classList.remove('sp-count--flash'); }, 450);
        }
        if(bar) {
            bar.classList.add('is-limit-flash');
            setTimeout(() => { bar.classList.remove('is-limit-flash'); }, 450);
        }
        if(toast) {
            toast.classList.add('is-visible');
            clearTimeout(flashLimitReached._hide);
            flashLimitReached._hide = setTimeout(() => {
                toast.classList.remove('is-visible');
            }, 3200);
        }
    }

    function updateSampleProgress() {
        const inCart = cartSampleCount();
        const selected = sampleState.selected.size;
        const count = Math.min(selected + inCart, sampleState.maxSamples);
        const atLimit = count >= sampleState.maxSamples;
        const countEl = document.getElementById('sp-count');
        const fillEl = document.getElementById('sp-progress-fill');
        const noteEl = document.getElementById('sp-limit-note');
        const btn = document.getElementById('sp-checkout-btn');
        if(countEl) countEl.textContent = count;
        if(fillEl) fillEl.style.width = ((count / sampleState.maxSamples) * 100) + '%';
        if(noteEl) {
            if(atLimit) {
                noteEl.hidden = false;
                noteEl.classList.add('is-maxed');
                noteEl.textContent = ' · Maximum reached';
            } else if(count > 0) {
                const remaining = sampleState.maxSamples - count;
                noteEl.hidden = false;
                noteEl.classList.remove('is-maxed');
                noteEl.textContent = remaining === 1 ? ' · 1 remaining' : ` · ${remaining} remaining`;
            } else {
                noteEl.hidden = true;
                noteEl.classList.remove('is-maxed');
                noteEl.textContent = '';
            }
        }
        if(btn) {
            const labelSpan = btn.querySelector('span');
            if(selected > 0) {
                btn.disabled = false;
                btn.dataset.action = 'checkout';
                if(labelSpan) labelSpan.textContent = `Proceed to Checkout (${selected})`;
            } else if(inCart > 0) {
                btn.disabled = false;
                btn.dataset.action = 'view-cart';
                if(labelSpan) labelSpan.textContent = 'View Cart';
            } else {
                btn.disabled = true;
                btn.dataset.action = 'checkout';
                if(labelSpan) labelSpan.textContent = 'Proceed to Checkout';
            }
        }
        syncSampleLimitUi();
    }

    function proceedSampleCheckout() {
        const btn = document.getElementById('sp-checkout-btn');
        if(btn && btn.dataset.action === 'view-cart') {
            if(typeof window.openVirtualDrawer === 'function') window.openVirtualDrawer();
            return;
        }
        if(sampleState.selected.size === 0) return;
        if(btn) {
            btn.classList.add('processing');
            btn.disabled = true;
        }

        // Build lookup map once
        const lookup = new Map(sampleState.all.map(s => [s.id, s]));

        // Merge into existing virtual cart, de-duping samples already present
        let cart = [];
        try { cart = JSON.parse(localStorage.getItem('virtual_cart') || '[]'); } catch(e) { cart = []; }
        cart = cart.filter(i => !i || i.product_type !== 'sample' || isChannelStocked('sample', i.fabric, i.colour));

        const existingSampleKey = new Set(
            cart.filter(i => i.product_type === 'sample')
                .map(i => `${i.fabric}|${i.colour}|${i.category || ''}`)
        );

        let sampleCount = cart.filter(i => i && i.product_type === 'sample').length;
        let added = 0;
        sampleState.selected.forEach(id => {
            const s = lookup.get(id);
            if(!s || s.available === false) return;
            if(sampleCount >= sampleState.maxSamples) return;
            const key = `${s.fabric}|${s.colour}|${s.category}`;
            if(existingSampleKey.has(key)) return;
            cart.push({
                id: Date.now() + Math.floor(Math.random() * 10000),
                product_type: 'sample',
                fabric: s.fabric,
                colour: s.colour,
                category: s.category,
                sample_type: s.type,
                group: s.group,
                price: 0,
                options: {}
            });
            existingSampleKey.add(key);
            sampleCount++;
            added++;
        });

        localStorage.setItem('virtual_cart', JSON.stringify(cart));

        // Clear selection now they're in the cart, then notify listeners
        sampleState.selected.clear();
        window.dispatchEvent(new Event('storage'));
        if(btn) btn.classList.remove('processing');
        updateSampleProgress();
        renderSampleGrid();

        // Open the virtual cart drawer so the user can checkout
        if(typeof window.openVirtualDrawer === 'function') {
            window.openVirtualDrawer();
        }
    }

    function initSamplePage() {
        sampleState.all = buildFlatSampleList();

        // Type toggle (All / Blinds / Curtains)
        document.querySelectorAll('.sp-type-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                document.querySelectorAll('.sp-type-btn').forEach(b => {
                    b.classList.remove('active');
                    b.setAttribute('aria-selected', 'false');
                });
                btn.classList.add('active');
                btn.setAttribute('aria-selected', 'true');
                sampleState.type = btn.dataset.type;
                // Reset category if it's no longer valid for this type
                const cats = availableCategoriesForType(sampleState.type);
                if(sampleState.category !== 'all' && cats.indexOf(sampleState.category) === -1) {
                    sampleState.category = 'all';
                }
                renderSampleFilterPills();
                renderSampleGrid();
            });
        });

        // Checkout button
        const checkoutBtn = document.getElementById('sp-checkout-btn');
        if(checkoutBtn) checkoutBtn.addEventListener('click', proceedSampleCheckout);

        window.addEventListener('storage', updateSampleProgress);

        renderSampleFilterPills();
        renderSampleGrid();
        updateSampleProgress();
    }

    window.openTab = function(evt, tabName) {
      document.querySelectorAll(".tab-pane").forEach(el => { el.style.display = "none"; el.classList.remove("active"); });
      document.querySelectorAll(".ind-tab-btn").forEach(el => el.classList.remove("active"));
      document.getElementById(tabName).style.display = "block";
      document.getElementById(tabName).classList.add("active");
      evt.currentTarget.classList.add("active");
    };
    
    function triggerSuccessModal() {
        const label = getMasterAtcLabelEl();
        if (!label) return;
        label.textContent = 'ADDED ✓';
        setTimeout(() => syncAtcDuplicateState(), 2000);
    }
    
    function initializeTooltips() {
        function closeAllTooltips() {
            document.querySelectorAll('.custom-tooltip-popup').forEach(popup => { popup.remove(); });
            document.querySelectorAll('.tooltip-icon').forEach(i => i.dataset.popupOpen = 'false');
        }
        document.querySelectorAll('.tooltip-icon').forEach(icon => {
            icon.addEventListener('click', function(event) {
                event.stopPropagation();
                const tooltipText = this.getAttribute('title');
                if (!tooltipText) return;
                if(this.dataset.popupOpen === 'true') { closeAllTooltips(); return; }
                closeAllTooltips();
                const popup = document.createElement('div');
                popup.className = 'custom-tooltip-popup';
                popup.innerText = tooltipText;
                document.body.appendChild(popup);
                this.dataset.popupOpen = 'true';
                popup.style.visibility = 'hidden';
                popup.style.display = 'block';
                const rect = this.getBoundingClientRect();
                const popupRect = popup.getBoundingClientRect();
                let top = rect.top + window.scrollY - popupRect.height - 8;
                let left = rect.left + window.scrollX + (rect.width / 2) - (popupRect.width / 2);
                if (top < window.scrollY + 10) { top = rect.bottom + window.scrollY + 8; }
                if (left < 10) left = 10;
                if ((left + popupRect.width) > window.innerWidth - 10) { left = window.innerWidth - popupRect.width - 10; }
                popup.style.left = left + 'px';
                popup.style.top = top + 'px';
                popup.style.visibility = '';
                popup.style.display = '';
                popup.classList.add('show');
            });
        });
        document.addEventListener('click', function(event) {
            if (!event.target.closest('.tooltip-icon')) { closeAllTooltips(); }
        });
    }

    /* ============================================================
       CONFIGURATOR REDESIGN ENGINE
       - Price display mirror (footer + sidebar card share state)
       - Live spec summary panel
       - Progressive-disclosure accordion step controller
       - Auto-advance on step completion (first time only)
       - Strict numeric validation for width/drop
       Only active for blind/curtain modes.
    ============================================================ */

    // Mirror any #custom-display-price value into every .cfg-price-mirror
    function syncPriceMirror() {
        if(MODE === 'sample') return;
        const src = document.getElementById('custom-display-price');
        if(!src) return;
        document.querySelectorAll('.cfg-price-mirror').forEach(el => {
            el.innerText = src.innerText;
            el.classList.toggle('cfg-price-value--placeholder', src.classList.contains('cfg-price-value--placeholder'));
        });
    }

    function currentFabricLabel() {
        if(isDoubleCurtainMode()) {
            const s = state.doubleSheerFabric, b = state.doubleBlockoutFabric;
            if(s && b) return `${s.name} + ${b.name}`;
            return '';
        }
        if(state.fabric) return state.fabric.name;
        return '';
    }

    function buildSummaryRows() {
        const rows = [];
        const pushRow = (label, value) => {
            if(value) rows.push({ label, value });
        };

        const nameEl = MODE === 'blind' ? document.getElementById('custom-input-name-b') : document.getElementById('custom-input-name-c');
        if(nameEl && nameEl.value.trim()) pushRow('Reference', nameEl.value.trim());

        if(isDoubleCurtainMode()) {
            if(state.doubleSheerFabric && state.doubleSheerColour) {
                pushRow('Sheer', `${state.doubleSheerFabric.name} · ${state.doubleSheerColour}`);
            }
            if(state.doubleBlockoutFabric && state.doubleBlockoutColour) {
                pushRow('Blockout', `${state.doubleBlockoutFabric.name} · ${state.doubleBlockoutColour}`);
            }
        } else {
            if(state.fabric) {
                const fabricText = state.colour
                    ? `${state.fabric.name} · ${state.colour}`
                    : `${state.fabric.name}`;
                pushRow('Fabric', fabricText);
                pushRow('Fabric Type', state.fabric.category);
            }
        }

        if(state.width || state.drop) {
            const d = state.drop || '-';
            if (MODE === 'curtain' && isWallToWall() && state.width) {
                pushRow('Opening', `${state.width} mm`);
                pushRow('Track', `${getFinishedTrackWidth(state.width)} mm (−20mm wall to wall)`);
                pushRow('Drop', `${d} mm`);
            } else {
                const w = state.width || '-';
                pushRow('Size', `${w} × ${d} mm`);
            }
        }

        if(MODE === 'blind') {
            pushRow('Mount', state.options.mount_blind);
            pushRow('Control Side', state.options.control);
            pushRow('Roll', state.options.roll);
            pushRow('Brackets', state.options.bracket);
            if(state.options.baseShape || state.options.baseColour) {
                const parts = [state.options.baseShape, state.options.baseColour].filter(Boolean).join(' · ');
                pushRow('Base Rail', parts);
            }
            pushRow('Motorisation', state.options.motor);
            pushRow('Chain Type', state.options.chain);
            pushRow('Motor Type', state.options.motorType);
            pushRow('Remote', state.options.remote);
        } else if(MODE === 'curtain') {
            pushRow('Wall to wall', state.options.wallToWall);
            pushRow('Mount', state.options.mount_curtain);
            if(state.options.mount_curtain === 'Face Fit' || isDoubleCurtainMode()) {
                pushRow('Bracket Type', state.options.bracketType_curtain);
            }
            pushRow('Stack Side', state.options.stack);
            pushRow('Track Colour', state.options.trackColour);
            pushRow('Hem', state.options.hemFinish);
            pushRow('Wand Length', state.options.wand);
        }

        return rows;
    }

    function renderFooterChips() {
        if(MODE === 'sample') return;
        const container = document.getElementById('cfg-footer-chips');
        if(!container) return;
        const rows = buildSummaryRows();
        const order = MODE === 'curtain'
            ? ['Fabric', 'Sheer', 'Blockout', 'Track', 'Size', 'Wall to wall']
            : ['Fabric', 'Size', 'Mount'];
        const chips = [];
        order.forEach(label => {
            const row = rows.find(r => r.label === label);
            if(row && chips.length < 4) chips.push(row);
        });
        container.innerHTML = chips.length
            ? chips.map(r => `<span class="cfg-footer-chip" title="${r.label}: ${r.value}"><span class="cfg-footer-chip-k">${r.label}</span> ${r.value}</span>`).join('')
            : '';
    }

    function renderSummary() {
        if(MODE === 'sample') return;
        const container = document.getElementById('cfg-summary-rows');
        if(!container) return;
        const rows = buildSummaryRows();
        if(rows.length === 0) {
            container.innerHTML = `<div class="cfg-summary-empty">Your selections will appear here as you build your ${MODE === 'blind' ? 'blind' : 'curtain'}.</div>`;
            renderFooterChips();
            return;
        }
        container.innerHTML = rows.map(r => `
            <div class="cfg-summary-row">
                <span class="cfg-sr-label">${r.label}</span>
                <span class="cfg-sr-value">${r.value}</span>
            </div>
        `).join('');
        renderFooterChips();
    }

    // ---- STEP COMPLETION + LOCK LOGIC ----
    function isStepDone(n) {
        if(n === 1) {
            if(MODE === 'curtain' && state.materialFilter === 'Blockout' && getVisibleFabricsForCurrentFilter().length === 0) {
                return false;
            }
            if(isDoubleCurtainMode()) {
                return !!(state.doubleSheerFabric && state.doubleSheerColour && state.doubleBlockoutFabric && state.doubleBlockoutColour);
            }
            return !!(state.fabric && state.colour);
        }
        if(n === 2) {
            const limits = getMeasureLimits();
            const sizeOk = state.width >= limits.minW && state.width <= limits.maxW && state.drop >= limits.minD && state.drop <= limits.maxD;
            if(MODE === 'curtain') return sizeOk && !!state.options.wallToWall;
            return sizeOk;
        }
        if(n === 3) {
            if(MODE === 'blind') {
                return !!(state.options.mount_blind && state.options.control && state.options.roll
                    && state.options.bracket && state.options.baseShape && state.options.baseColour);
            }
            // curtain
            const baseDone = !!(state.options.mount_curtain && state.options.stack && state.options.trackColour && state.options.hemFinish);
            if(!baseDone) return false;
            // Face fit (single) requires bracket type. Double forces Double bracket automatically.
            if(!isDoubleCurtainMode() && state.options.mount_curtain === 'Face Fit') {
                return !!state.options.bracketType_curtain;
            }
            return true;
        }
        if(n === 4) {
            if(MODE === 'blind') {
                const isMotor = (state.options.motor || '').toLowerCase().includes('motor');
                if(isMotor) return !!(state.options.motorType && state.options.remote);
                // Default / Chain path — chain type required
                return !!state.options.chain;
            }
            // curtain
            return !!state.options.wand;
        }
        return false;
    }

    function getStepPreview(n) {
        if(n === 1) {
            if(isDoubleCurtainMode()) {
                if(state.doubleSheerFabric && state.doubleBlockoutFabric) {
                    return `${state.doubleSheerFabric.name} + ${state.doubleBlockoutFabric.name}`;
                }
                return '';
            }
            if (state.fabric && state.colour) return `${state.fabric.name} · ${state.colour}`;
            if (state.fabric) return state.fabric.name;
            return '';
        }
        if(n === 2) {
            if(MODE === 'curtain' && state.options.wallToWall && state.width && state.drop) {
                const track = isWallToWall() ? getFinishedTrackWidth(state.width) : state.width;
                return `${track} × ${state.drop} mm`;
            }
            if(state.width && state.drop) return `${state.width} × ${state.drop} mm`;
            return '';
        }
        if(n === 3) {
            if(MODE === 'blind') return state.options.mount_blind || '';
            return [state.options.mount_curtain, state.options.hemFinish].filter(Boolean).join(' · ');
        }
        if(n === 4) {
            if(MODE === 'blind') {
                const isMotor = (state.options.motor || '').toLowerCase().includes('motor');
                if(isMotor) return state.options.motorType ? 'Motorised' : '';
                return state.options.chain || '';
            }
            return state.options.wand || '';
        }
        return '';
    }

    function getOpenStepNumber() {
        const open = document.querySelector('.cfg-step.cfg-step--open');
        return open ? Number(open.dataset.step) : 1;
    }

    function openStep(n) {
        const step = document.getElementById('cfg-step-' + n);
        if(!step || step.classList.contains('cfg-step--locked')) return;
        document.querySelectorAll('.cfg-step.cfg-step--open').forEach(s => s.classList.remove('cfg-step--open'));
        document.querySelectorAll('.cfg-step.cfg-step--enter').forEach(s => s.classList.remove('cfg-step--enter'));
        step.classList.add('cfg-step--open');
        void step.offsetWidth;
        step.classList.add('cfg-step--enter');
        hydrateDeferredImages(step);
        updateStepNavButtons();
        syncFocusGroups();
        syncStepChrome(n);
        syncStepRecap(n);
        if(n === 4) pulseAtcButton();
        scrollOpenedStepIntoView(step);
    }

    function isBlockoutEmptyCurtain() {
        return MODE === 'curtain'
            && state.materialFilter === 'Blockout'
            && getVisibleFabricsForCurrentFilter().length === 0;
    }

    function updateStepNavButtons() {
        syncAtcDuplicateState();

        document.querySelectorAll('.cfg-step').forEach(step => {
            const num = Number(step.dataset.step);
            const nav = step.querySelector('.cfg-step-nav');
            if(!nav) return;
            const back = nav.querySelector('[data-step-back]');
            const cont = nav.querySelector('[data-step-continue]');
            if(back) back.hidden = num === 1;
            if(cont) {
                if(num === 4) {
                    cont.hidden = false;
                    cont.classList.add('cfg-step-continue--atc');
                } else {
                    cont.hidden = false;
                    cont.textContent = 'Continue';
                    cont.classList.remove('cfg-step-continue--atc');
                    cont.disabled = num === 1 && isBlockoutEmptyCurtain();
                }
            }
        });
    }

    function getVizLaunchers() {
        return ['cfg-viz-pill', 'cfg-viz-launch']
            .map((id) => document.getElementById(id))
            .filter(Boolean);
    }

    function setVizLauncherExpanded(expanded) {
        getVizLaunchers().forEach((launcher) => {
            launcher.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
    }

    async function openVizDrawer() {
        const drawer = document.getElementById('cfg-viz-drawer');
        const overlay = document.getElementById('cfg-viz-overlay');
        if(!drawer) return;
        drawer.hidden = false;
        drawer.setAttribute('aria-hidden', 'false');
        if(overlay) {
            overlay.hidden = false;
            overlay.setAttribute('aria-hidden', 'false');
        }
        setVizLauncherExpanded(true);
        document.body.classList.add('cfg-viz-open');
        hydrateDeferredImages(document.getElementById('fabric-preview-stage'));
        if (state.fabric && state.colour) {
            updateFabricThumbGrid(state.fabric.name, state.colour);
        } else if (isDoubleCurtainMode() && state.doubleSheerFabric && state.doubleSheerColour) {
            updateFabricThumbGrid(state.doubleSheerFabric.name, state.doubleSheerColour);
        }

        const engine = await ensureVisualizer();
        await waitForRoomPhoto(document.getElementById('viz-room-bg'));
        await new Promise((resolve) => requestAnimationFrame(resolve));
        if (engine) engine.resize();
        await refreshVisualizer();
    }

    function closeVizDrawer() {
        const drawer = document.getElementById('cfg-viz-drawer');
        const overlay = document.getElementById('cfg-viz-overlay');
        if(drawer) {
            drawer.hidden = true;
            drawer.setAttribute('aria-hidden', 'true');
        }
        if(overlay) {
            overlay.hidden = true;
            overlay.setAttribute('aria-hidden', 'true');
        }
        setVizLauncherExpanded(false);
        document.body.classList.remove('cfg-viz-open');
    }

    function toggleVizDrawer() {
        const drawer = document.getElementById('cfg-viz-drawer');
        if(drawer?.hidden) openVizDrawer();
        else closeVizDrawer();
    }

    function nudgeVizPill() {
        if (MODE === 'sample' || !_vizUiReady) return;
        const drawer = document.getElementById('cfg-viz-drawer');
        if (!drawer?.hidden) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        getVizLaunchers().forEach((launcher) => {
            launcher.classList.remove('cfg-viz-pill--nudge');
            void launcher.offsetWidth;
            launcher.classList.add('cfg-viz-pill--nudge');
        });
    }

    function syncVizThumbTarget(thumbEl, url, size) {
        if (!thumbEl) return;
        let img = thumbEl.querySelector('img');
        if (!img) {
            img = document.createElement('img');
            img.alt = '';
            img.decoding = 'async';
            img.width = size;
            img.height = size;
            thumbEl.appendChild(img);
        }
        if (img.getAttribute('src') !== url) img.src = url;
    }

    function syncVizPillThumb() {
        const fabricName = state.fabric?.name || state.doubleSheerFabric?.name;
        const colourName = state.colour || state.doubleSheerColour;
        const pillThumb = document.getElementById('cfg-viz-pill-thumb');
        const launchThumb = document.getElementById('cfg-viz-launch-thumb');

        if (!fabricName || !colourName) {
            if (pillThumb) pillThumb.replaceChildren();
            if (launchThumb) {
                const fallback = launchThumb.querySelector('[data-viz-launch-fallback]');
                if (!fallback) {
                    launchThumb.replaceChildren();
                }
            }
            return;
        }

        const url = getUrl('swatch', fabricName, colourName);
        syncVizThumbTarget(pillThumb, url, 40);
        syncVizThumbTarget(launchThumb, url, 48);
    }

    function refreshStepLocks() {
        if(MODE === 'sample') return;
        const steps = [1, 2, 3, 4];
        let prevAllDone = true;
        let activeStep = getOpenStepNumber();

        steps.forEach(n => {
            const el = document.getElementById('cfg-step-' + n);
            if(!el) return;

            const done = isStepDone(n);
            const locked = n === 1 ? false : !prevAllDone;

            el.classList.toggle('cfg-step--locked', locked);
            el.classList.toggle('cfg-step--done', done && !locked);

            const previewEl = el.querySelector(`[data-step-preview="${n}"]`);
            if (previewEl) previewEl.textContent = locked ? '' : getStepPreview(n);

            const stepperNode = document.querySelector(`[data-step-goto="${n}"]`);
            if(stepperNode) {
                stepperNode.classList.toggle('is-locked', locked);
                stepperNode.classList.toggle('is-done', done && !locked);
                stepperNode.classList.toggle('is-active', activeStep === n && !locked);
                stepperNode.disabled = locked;
                if(activeStep === n && !locked) {
                    stepperNode.setAttribute('aria-current', 'step');
                } else {
                    stepperNode.removeAttribute('aria-current');
                }
            }

            if(locked) el.classList.remove('cfg-step--open');
            prevAllDone = prevAllDone && done;
        });

        const anyOpen = document.querySelector('.cfg-step.cfg-step--open');
        if(!anyOpen) {
            const firstUnlocked = document.querySelector('.cfg-step:not(.cfg-step--locked)');
            if(firstUnlocked) {
                firstUnlocked.classList.add('cfg-step--open');
                hydrateDeferredImages(firstUnlocked);
            }
        }

        activeStep = getOpenStepNumber();
        steps.forEach(n => {
            const stepperNode = document.querySelector(`[data-step-goto="${n}"]`);
            if(!stepperNode) return;
            const locked = stepperNode.classList.contains('is-locked');
            stepperNode.classList.toggle('is-active', activeStep === n && !locked);
            if(activeStep === n && !locked) stepperNode.setAttribute('aria-current', 'step');
            else stepperNode.removeAttribute('aria-current');
        });
        updateStepNavButtons();
        syncStepChrome(activeStep);
        syncFocusGroups();
    }

    // Called by updateProgressBubbles() after state mutations
    function refreshCfgUI() {
        if(MODE === 'sample') return;
        renderSummary();
        refreshStepLocks();
        syncPriceMirror();
        syncFocusGroups();
        syncAtcDuplicateState();
        const openN = getOpenStepNumber();
        if(openN === 4) syncStepRecap(4);
    }

    function isConfigurationComplete() {
        return isStepDone(1) && isStepDone(2) && isStepDone(3) && isStepDone(4);
    }

    // Mobile-only helper: after a step is expanded, bring its header
    // just below the sticky visualiser. The previous accordion behaviour
    // would collapse the currently-open step (shrinking the page above
    // the tap point) and leave the user stranded near the bottom of the
    // form. On desktop the sidebar/visualiser live side-by-side so no
    // scroll adjustment is needed.
    function scrollOpenedStepIntoView() {
        if(MODE === 'sample') return;
        const anchor = document.querySelector('.cfg-form-header')
            || document.querySelector('.cfg-stepper')
            || document.querySelector('.cfg-shell--pathway');
        if(!anchor) {
            window.scrollTo({ top: 0, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
            return;
        }
        const y = anchor.getBoundingClientRect().top + window.scrollY - 8;
        window.scrollTo({
            top: Math.max(0, y),
            behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
    }

    function getOrientationStorageKey() {
        return 'byb-cfg-started-' + MODE;
    }

    function getConfiguratorRoot() {
        return document.querySelector('.industrial-configurator.mode-' + MODE)
            || document.querySelector('.industrial-configurator');
    }

    function orientationAlreadyStarted() {
        try {
            const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
            if (!nav || nav.type !== 'reload') return false;
            return sessionStorage.getItem(getOrientationStorageKey()) === '1';
        } catch (e) {
            return false;
        }
    }

    function markOrientationStarted() {
        try {
            sessionStorage.setItem(getOrientationStorageKey(), '1');
        } catch (e) {}
    }

    function copyOrientationNameToReference() {
        const nickname = document.getElementById('cfg-orient-name')?.value?.trim() || '';
        if(!nickname) return;
        const target = getReferenceNameInput();
        if(!target) return;
        target.value = nickname;
        target.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function focusFirstFabricControl() {
        const control = document.querySelector('#cfg-step-1 .ind-pill-btn')
            || document.querySelector('#fabric-thumb-grid .fabric-thumb');
        control?.focus();
    }

    function enterBuilderFromOrientation() {
        const root = getConfiguratorRoot();
        if(root) root.classList.add('is-building');
        markOrientationStarted();
        copyOrientationNameToReference();
        scrollOpenedStepIntoView();
        focusFirstFabricControl();
    }

    function initOrientationGate() {
        const startBtn = document.getElementById('cfg-orient-start');
        if(!startBtn) return;

        const root = getConfiguratorRoot();
        if(root && orientationAlreadyStarted() && !root.classList.contains('is-building')) {
            root.classList.add('is-building');
        }

        const handleStart = (e) => {
            if(e) e.preventDefault();
            enterBuilderFromOrientation();
        };

        startBtn.addEventListener('click', handleStart);

        window.addEventListener('pageshow', (e) => {
            if (!e.persisted) return;
            const liveRoot = getConfiguratorRoot();
            liveRoot?.classList.remove('is-building');
        });

        const orientName = document.getElementById('cfg-orient-name');
        if(orientName) {
            orientName.addEventListener('keydown', (e) => {
                if(e.key === 'Enter') {
                    e.preventDefault();
                    handleStart(e);
                }
            });
        }
    }

    // ---- ACCORDION TOGGLES + NUMERIC VALIDATION ----
    function initCfgUI() {
        if(MODE === 'sample') return;

        initOrientationGate();

        document.querySelectorAll('.cfg-step-head[data-step-toggle]').forEach(btn => {
            btn.addEventListener('click', () => {
                const step = btn.closest('.cfg-step');
                if(!step || step.classList.contains('cfg-step--locked')) return;
                openStep(Number(btn.dataset.stepToggle));
            });
        });

        document.querySelectorAll('[data-step-goto]').forEach(btn => {
            btn.addEventListener('click', () => {
                const n = Number(btn.dataset.stepGoto);
                if(!n || btn.disabled || btn.classList.contains('is-locked')) return;
                openStep(n);
            });
        });

        document.querySelectorAll('[data-step-continue]').forEach(btn => {
            btn.addEventListener('click', () => {
                const step = btn.closest('.cfg-step');
                const n = Number(step?.dataset.step);
                if(!n) return;
                if(n === 4) {
                    if(!isStepDone(4)) {
                        validateSelection();
                        return;
                    }
                    document.getElementById('master-atc-btn')?.click();
                    return;
                }
                if(isStepDone(n)) {
                    if(n < 4) openStep(n + 1);
                    return;
                }
                if(n === 2) {
                    const w = parseInt(document.getElementById('custom-input-width')?.value) || 0;
                    const d = parseInt(document.getElementById('custom-input-drop')?.value) || 0;
                    state.width = w;
                    state.drop = d;
                }
                validateSelection();
            });
        });

        document.querySelectorAll('[data-step-back]').forEach(btn => {
            btn.addEventListener('click', () => {
                const step = btn.closest('.cfg-step');
                const n = Number(step?.dataset.step);
                if(n > 1) openStep(n - 1);
            });
        });

        const vizOverlay = document.getElementById('cfg-viz-overlay');
        const vizClose = document.getElementById('cfg-viz-close');
        getVizLaunchers().forEach((launcher) => {
            launcher.addEventListener('animationend', (e) => {
                if (e.animationName === 'cfg-viz-pill-nudge') {
                    launcher.classList.remove('cfg-viz-pill--nudge');
                }
            });
            launcher.addEventListener('click', toggleVizDrawer);
        });
        if(vizOverlay) vizOverlay.addEventListener('click', closeVizDrawer);
        if(vizClose) vizClose.addEventListener('click', closeVizDrawer);
        document.addEventListener('keydown', (e) => {
            if(e.key === 'Escape') closeVizDrawer();
        });

        const switchSheer = document.getElementById('cfg-switch-sheer');
        if(switchSheer) {
            switchSheer.addEventListener('click', () => {
                const sheerPill = document.querySelector('.ind-pill-btn[data-material="Sheer"]');
                if(sheerPill) sheerPill.click();
            });
        }

        // Strict numeric input stripping for width/drop
        const numFields = document.querySelectorAll('.cfg-numeric');
        numFields.forEach(input => {
            input.addEventListener('input', function() {
                const clean = this.value.replace(/\D/g, '');
                if(clean.length > 5) {
                    this.value = clean.slice(0, 5);
                } else if(this.value !== clean) {
                    this.value = clean;
                }
            });
            // Reject non-numeric paste
            input.addEventListener('paste', function(e) {
                const pasted = (e.clipboardData || window.clipboardData).getData('text') || '';
                if(/\D/.test(pasted)) {
                    e.preventDefault();
                    const clean = pasted.replace(/\D/g, '').slice(0, 5);
                    document.execCommand && document.execCommand('insertText', false, clean);
                }
            });
        });

        // Reference name: refresh summary and clear validation as user types
        const refInputs = document.querySelectorAll('.cfg-reference-input');
        refInputs.forEach(input => {
            input.addEventListener('input', function() {
                if (this.value.trim().length > 0) setReferenceNameError(false);
                refreshCfgUI();
            });
        });

        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState !== 'visible') return;
            const priceDisplay = document.getElementById('custom-display-price');
            if (priceDisplay?.innerText === 'Error') {
                window.calculatePrice({ immediate: true });
            }
        });

        // Initial render
        resetPriceDisplay();
        refreshCfgUI();
        syncStepChrome(getOpenStepNumber());
        _vizUiReady = true;
    }

    init();
    if(MODE === 'blind' || MODE === 'curtain') {
        initCfgUI();
        hydrateDeferredImages(document.querySelector('.cfg-step--open'));
    }
    
    // Switch Material Filter (Blockout / Screen etc)
    document.querySelectorAll('.ind-pill-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
            document.querySelectorAll('.ind-pill-btn').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            
            resetSelection();
            
            state.materialFilter = btn.dataset.material;
            
            if(MODE === 'curtain') {
                applyCurtainMaterialVisual();
                syncCurtainModeUi();
            }
            renderFabrics();
            updateStepNavButtons();
        });
    });

  });
